
import { Injectable } from "@nestjs/common";
import { Cron } from "@nestjs/schedule";
import { CoLineModel, CoLineRequest, coLineRequest, Color, CommonResponseModel, CompareModel, Destination, ItemStatusEnum, OrderDataModel, OrderRevertModel, OrderSizeWiseModel, PoOrderFilter, RLOrderFilter, Size } from "@project-management-system/shared-models";
import * as AdmZip from 'adm-zip';
import * as nodemailer from 'nodemailer';
import puppeteer from "puppeteer";
import { DataSource } from "typeorm";
import { GenericTransactionManager } from "../../typeorm-transactions";
import { AddressService } from "../Entites@Shahi/address/address-service";
import { ColorRepository } from "../Entites@Shahi/color/color.repo";
import { ItemNoDtos } from "./dto/item-no.dto";
import { OrderDetailsReq } from "./dto/order-details-req";
import { COLineEntity } from "./entities/co-line.entity";
import { EditRlCOLineEntity } from "./entities/edit-co-line.entity";
import { PdfFileUploadEntity } from "./entities/pdf-file-upload.entity";
import { RLOrderschildEntity } from "./entities/rl-orders-child.entity";
import { RLOrdersEntity } from "./entities/rl-orders.entity";
import { COLineRepository } from "./repositories/co-line.repository";
import { EditRlCOLineRepository } from "./repositories/edit-co-line.repo";
import { PdfFileUploadRepository } from "./repositories/pdf-file.repo";
import { RLOrdersChildRepository } from "./repositories/rl-orders-child.repo";
import { RLOrdersRepository } from "./repositories/rl-orders.repo";
const { Builder, Browser, By, Select, until, Key } = require('selenium-webdriver');
const fs = require('fs');
const path = require('path')
@Injectable()
export class RLOrdersService {
  constructor(
    private rlOrdersRepo: RLOrdersRepository,
    private pdfrepo: PdfFileUploadRepository,
    private coLineRepo: COLineRepository,
    private dataSource: DataSource,
    private addressService: AddressService,
    private orderChildRepo: RLOrdersChildRepository,
    private colorRepo: ColorRepository,
    private editrlCoLineRepository: EditRlCOLineRepository


  ) { }

  async saveOrdersDataFromPDF(req: any): Promise<CommonResponseModel> {
    const transactionManager = new GenericTransactionManager(this.dataSource)
    try {
      let saved
      let version = 1;
      await transactionManager.startTransaction()
      const orderData = await this.rlOrdersRepo.find({ where: { poNumber: req.poNumber } })
      const order = await this.orderChildRepo.findOne({ where: { poNumber: req.poNumber }, order: { poVersion: 'DESC' } })
      if (orderData) {
        const deleteData = await transactionManager.getRepository(RLOrdersEntity).delete({ poNumber: req.poNumber })
      }
      if (order)
        version = Number(order.poVersion) + 1
      for (const item of req.poItemDetails) {
        const match = item.poItem.match(/\d+/);
        // Check if a match is found and convert it to an integer
        const poItem = match ? parseInt(match[0], 10) : null;
        for (const variant of item.poItemVariantDetails) {

          const entity = new RLOrdersEntity()
          entity.agent = req.agent
          entity.amount = variant.amount
          entity.boardCode = item.board
          entity.buyer = 'RL'
          entity.color = item.colorDescription
          entity.currency = variant.currency
          entity.materialNo = item.materialNo
          entity.poItem = poItem
          entity.poNumber = req.poNumber
          entity.poUploadDate = req.poIssue
          entity.price = variant.unitPrice
          entity.purchaseGroup = req.purchaseGroup
          entity.quantity = variant.quantity
          entity.revisionNo = req.revisionNo
          entity.seasonCode = item.season
          entity.handoverDate = item.handoverDate
          entity.shipToAddress = req.shipToAddress
          entity.billToAddress = req.buyerAddress
          entity.size = variant.size
          entity.status = req.revisionNo == 1 ? 'New' : 'Revised'
          entity.upcEan = variant.upc

          saved = await transactionManager.getRepository(RLOrdersEntity).save(entity)

          const entitys = new RLOrderschildEntity()
          entitys.agent = req.agent
          entitys.amount = variant.amount
          entitys.boardCode = item.board
          entitys.buyer = 'RL'
          entitys.color = item.colorDescription
          entitys.currency = variant.currency
          entitys.materialNo = item.materialNo
          entitys.poItem = poItem
          entitys.poNumber = req.poNumber
          entitys.poUploadDate = req.poIssue
          entitys.price = variant.unitPrice
          entitys.purchaseGroup = req.purchaseGroup
          entitys.quantity = variant.quantity
          entitys.revisionNo = req.revisionNo
          entitys.seasonCode = item.season
          entitys.handoverDate = item.handoverDate
          entitys.shipToAddress = req.shipToAddress
          entitys.billToAddress = req.buyerAddress
          entitys.size = variant.size
          entitys.status = req.revisionNo == 1 ? 'New' : 'Revised'
          entitys.upcEan = variant.upc
          entitys.poVersion = version.toString()
          entitys.orderId = saved.id
          entitys.itemStatus = ItemStatusEnum.OPEN

          const savedChild = await transactionManager.getRepository(RLOrderschildEntity).save(entitys)
          if (!saved) {
            throw new Error('Save failed')
          }
        }
      }
      await transactionManager.completeTransaction()
      return new CommonResponseModel(true, 1, 'Data saved successfully', saved)
    } catch (err) {
      await transactionManager.releaseTransaction()
      return new CommonResponseModel(false, 0, 'Failed', err)
    }
  }


  async getPdfFileInfo(req?: PoOrderFilter): Promise<CommonResponseModel> {
    // eslint-disable-next-line no-useless-catch
    try {
      const data = await this.pdfrepo.find({ where: { poNumber: req.poNumber } })
      // const data = await this.pdfrepo.find({ where: { status: StatusTypeEnum.NOT_CANCELLED } });
      if (data) {
        return new CommonResponseModel(true, 1, 'data retrieved Successfully', data);
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', []);
      }
    } catch (err) {
      throw err;
    }
  }

  async getorderData(req?: PoOrderFilter): Promise<CommonResponseModel> {
    try {
      const details = await this.rlOrdersRepo.getorderData(req);
      if (details.length === 0) {
        return new CommonResponseModel(false, 0, 'data not found');
      }
      const sizeDateMap = new Map<string, OrderDataModel>();
      for (const rec of details) {
        if (!sizeDateMap.has(`${rec.po_number},${rec.po_item}`)) {
          sizeDateMap.set(
            `${rec.po_number},${rec.po_item}`,
            new OrderDataModel(rec.id, rec.po_number, rec.po_item, rec.ship_to_address, rec.agent, rec.purchase_group, rec.supplier, rec.revision_no, rec.po_upload_date, rec.status, rec.division, rec.ship_to, rec.season_code, rec.board_code, rec.style, rec.material_no, rec.rl_style_no, rec.color, rec.size, rec.total_qty, rec.ship_date, rec.ship_mode, rec.msrp_price, rec.msrp_currency, rec.c_s_price, rec.c_s_currency, rec.amount, rec.total_amount, rec.price, rec.currency, rec.quantity, rec.upc_ean, [], rec.item_status, rec.handover_date)
          );
        }
        const sizeWiseData = sizeDateMap.get(`${rec.po_number},${rec.po_item}`).sizeWiseData;
        if (rec.size !== null) {
          sizeWiseData.push(new OrderSizeWiseModel(rec.size, rec.total_qty, rec.msrp_price, rec.msrp_currency, rec.c_s_price, rec.c_s_currency, rec.amount, rec.total_amount, rec.price, rec.currency, rec.quantity, rec.upc_ean));
        }
      }
      const dataModelArray: OrderDataModel[] = Array.from(sizeDateMap.values());
      return new CommonResponseModel(true, 1, 'data retrieved', dataModelArray);
    } catch (e) {
      return new CommonResponseModel(false, 0, 'failed', e);
    }
  }

  async getorderDataforAcceptance(req?: PoOrderFilter): Promise<CommonResponseModel> {
    try {
      const details = await this.rlOrdersRepo.getorderDataforAcceptance(req);
      if (details.length === 0) {
        return new CommonResponseModel(false, 0, 'data not found');
      }
      const sizeDateMap = new Map<string, OrderDataModel>();
      for (const rec of details) {
        if (!sizeDateMap.has(`${rec.po_number},${rec.po_item}`)) {
          sizeDateMap.set(
            `${rec.po_number},${rec.po_item}`,
            new OrderDataModel(rec.id, rec.po_number, rec.po_item, rec.ship_to_address, rec.agent, rec.purchase_group, rec.supplier, rec.revision_no, rec.po_upload_date, rec.status, rec.division, rec.ship_to, rec.season_code, rec.board_code, rec.style, rec.material_no, rec.rl_style_no, rec.color, rec.size, rec.total_qty, rec.ship_date, rec.ship_mode, rec.msrp_price, rec.msrp_currency, rec.c_s_price, rec.c_s_currency, rec.amount, rec.total_amount, rec.price, rec.currency, rec.quantity, rec.upc_ean, [], rec.item_status, rec.handover_date)
          );
        }
        const sizeWiseData = sizeDateMap.get(`${rec.po_number},${rec.po_item}`).sizeWiseData;
        if (rec.size !== null) {
          sizeWiseData.push(new OrderSizeWiseModel(rec.size, rec.total_qty, rec.msrp_price, rec.msrp_currency, rec.c_s_price, rec.c_s_currency, rec.amount, rec.total_amount, rec.price, rec.currency, rec.quantity, rec.upc_ean));
        }
      }
      const dataModelArray: OrderDataModel[] = Array.from(sizeDateMap.values());
      return new CommonResponseModel(true, 1, 'data retrieved', dataModelArray);
    } catch (e) {
      return new CommonResponseModel(false, 0, 'failed', e);
    }
  }

  async getorderDataByPoNumber(req: PoOrderFilter): Promise<CommonResponseModel> {
    try {
      const data = await this.rlOrdersRepo.getorderDataByPoNumber(req)
      if (data) {
        return new CommonResponseModel(true, 1, 'data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  // async getOrderDetails(req: OrderDetailsReq): Promise<CommonResponseModel> {
  //   try {
  //     const data = await this.rlOrdersRepo.find({ where: { poNumber: req.poNumber } })

  //     // po -> destination -> color -> sizes
  //     const destinationColSizesMap = new Map<string, Map<string, Map<string, { size: string, quantity: number, price: string }[]>>>();
  //     const poMap = new Map<string, RLOrdersEntity>();
  //     data.forEach(rec => {

  //       poMap.set(rec.poNumber, rec)
  //       const destCountry = rec.shipToAddress.slice(-2).trim();
  //       const parts = rec.shipToAddress.split(',')
  //       const destAdd = parts[0].trim();
  //       const dest = destAdd + ',' + destCountry;
  //       if (!destinationColSizesMap.has(rec.poNumber)) {
  //         destinationColSizesMap.set(rec.poNumber, new Map<string, Map<string, []>>());
  //       }
  //       if (!destinationColSizesMap.get(rec.poNumber).has(dest)) {
  //         destinationColSizesMap.get(rec.poNumber).set(dest, new Map<string, []>());
  //       }

  //       if (!destinationColSizesMap.get(rec.poNumber).get(dest).has(rec.color)) {
  //         destinationColSizesMap.get(rec.poNumber).get(dest).set(rec.color, []);
  //       }
  //       destinationColSizesMap.get(rec.poNumber).get(dest).get(rec.color).push({ size: rec.size, quantity: rec.quantity, price: rec.price });
  //     });
  //     const coData = []
  //     destinationColSizesMap.forEach((destColorSize, poNumber) => {
  //       const desArray = []
  //       destColorSize.forEach((colorSizes, dest) => {
  //         const ColArray = []
  //         colorSizes.forEach((sizes, color) => {
  //           const sizeArray = []
  //           sizes.forEach((size) => {
  //             const sizeObj = new Size(size.size, size.quantity, size.price);
  //             sizeArray.push(sizeObj)
  //           })
  //           const col = new Color(color, sizeArray);
  //           ColArray.push(col)
  //         });
  //         const des = new Destination(dest, ColArray);
  //         desArray.push(des)
  //       });
  //       const poInfo = poMap.get(poNumber)
  //       const co = new CoLineModel(poInfo.poNumber, poInfo.poItem, poInfo.price, poInfo.currency, poInfo.handoverDate, poInfo.materialNo, desArray);
  //       coData.push(co)
  //     });
  //     if (coData) {
  //       return new CommonResponseModel(true, 1, 'Data Retrived Sucessfully', coData);
  //     } else {
  //       return new CommonResponseModel(false, 0, 'No data found');
  //     }
  //   } catch (err) {
  //     throw err
  //   }
  // }


  async getOrderDetails(req: OrderDetailsReq): Promise<CommonResponseModel> {
    try {
      const data = await this.rlOrdersRepo.find({ where: { poNumber: req.poNumber, poItem: req.poLine } });

      // po -> destination -> color -> sizes
      const destinationColSizesMap = new Map<string, Map<string, Map<string, { size: string, quantity: number, price: string }[]>>>();
      const poMap = new Map<string, RLOrdersEntity>();

      for (const rec of data) {
        poMap.set(rec.poNumber, rec);
        // const destCountry = rec.shipToAddress.slice(-2).trim();
        // const parts = rec.shipToAddress.split(',');
        // const destAdd = parts[0].trim();
        // const dest = destAdd + ',' + destCountry;
        const dest = rec.shipToAddress


        if (!destinationColSizesMap.has(rec.poNumber)) {
          destinationColSizesMap.set(rec.poNumber, new Map<string, Map<string, { size: string, quantity: number, price: string }[]>>());
        }
        if (!destinationColSizesMap.get(rec.poNumber).has(dest)) {
          destinationColSizesMap.get(rec.poNumber).set(dest, new Map<string, { size: string, quantity: number, price: string }[]>());
        }

        const check = await this.colorRepo.find({
          where: {
            poNumber: rec.poNumber,
            style: rec.materialNo,
            rlField: rec.color
          }
        });

        if (Array.isArray(check) && check.length > 0) {
          const crmField = check[0].crmField;
          if (!destinationColSizesMap.get(rec.poNumber).get(dest).has(crmField)) {
            destinationColSizesMap.get(rec.poNumber).get(dest).set(crmField, []);
          }
          destinationColSizesMap.get(rec.poNumber).get(dest).get(crmField).push({ size: rec.size, quantity: rec.quantity, price: rec.price });
        } else {
          if (!destinationColSizesMap.get(rec.poNumber).get(dest).has(rec.color)) {
            destinationColSizesMap.get(rec.poNumber).get(dest).set(rec.color, []);
          }
          destinationColSizesMap.get(rec.poNumber).get(dest).get(rec.color).push({ size: rec.size, quantity: rec.quantity, price: rec.price });
        }
      }

      const coData = [];
      destinationColSizesMap.forEach((destColorSize, poNumber) => {
        const desArray = [];
        destColorSize.forEach((colorSizes, dest) => {
          const ColArray = [];
          colorSizes.forEach((sizes, color) => {
            const sizeArray = sizes.map(size => new Size(size.size, size.quantity, size.price));
            const col = new Color(color, sizeArray);
            ColArray.push(col);
          });
          const des = new Destination(dest, ColArray);
          desArray.push(des);
        });
        const poInfo = poMap.get(poNumber);
        const co = new CoLineModel(poInfo.poNumber, poInfo.poItem, poInfo.price, poInfo.currency, poInfo.handoverDate, poInfo.materialNo, desArray);
        coData.push(co);
      });

      if (coData.length > 0) {
        return new CommonResponseModel(true, 1, 'Data Retrieved Successfully', coData);
      } else {
        return new CommonResponseModel(false, 0, 'No data found');
      }
    } catch (err) {
      throw err;
    }
  }


  async coLineCreationReq(req: any): Promise<CommonResponseModel> {
    console.log(req, "8888888")
    try {
      if (req.itemNo == undefined || null) {
        return new CommonResponseModel(false, 0, 'Please enter Item No')
      }
      const entity = new COLineEntity()
      entity.buyer = req.buyer
      entity.buyerPo = req.purchaseOrderNumber;
      entity.lineItemNo = req.poLineItemNumber;
      entity.itemNo = req.itemNo
      entity.status = 'Open';
      entity.createdUser = req.createdUser;
      const save = await this.coLineRepo.save(entity);
      if (save) {
        const update = await this.rlOrdersRepo.update({
          poNumber: req.purchaseOrderNumber,
          poItem: req.poLineItemNumber


        }, { itemStatus: ItemStatusEnum.INPROGRESS })
        return new CommonResponseModel(true, 1, 'CO-Line request created successfully', save)
      } else {
        return new CommonResponseModel(false, 0, 'CO-Line request failed')
      }
    } catch (err) {
      return new CommonResponseModel(false, 0, 'CO-Line request failed', err)
    }
  }

  @Cron('0 8 * * *')
  async getTradeLinkPdf(): Promise<CommonResponseModel> {
    let driver = await new Builder().forBrowser(Browser.CHROME).build();
    try {
      await driver.get('https://www.tradelinkone.com/')
      await driver.wait(until.elementLocated(By.id('wt-cli-accept-all-btn')))
      const acceptButton = await driver.findElement(By.id('wt-cli-accept-all-btn'));
      await acceptButton.click();
      await driver.wait(until.elementLocated(By.id('forminator-field-text-1')))
      await driver.findElement(By.id('forminator-field-text-1')).sendKeys('sounder.kumar@shahi.co.in');
      await driver.wait(until.elementLocated(By.id('forminator-field-password-1')))
      await driver.findElement(By.id('forminator-field-password-1')).sendKeys('6A09CD34C2');
      await driver.wait(until.elementLocated(By.xpath('//*[@id="forminator-module-3303"]/div[4]/div/div/button')))
      await driver.findElement(By.xpath('//*[@id="forminator-module-3303"]/div[4]/div/div/button')).click();
      await driver.wait(until.elementLocated(By.xpath('//*[@id="ui-id-10"]/div[1]/a')))
      await driver.findElement(By.xpath('//*[@id="ui-id-10"]/div[1]/a')).click();
      await driver.sleep(10000)
      await driver.wait(until.elementLocated(By.xpath('//*[@id="tab1"]/div[1]/div[1]/div[2]')))
      await driver.findElement(By.xpath('//*[@id="tab1"]/div[1]/div[1]/div[2]')).click();
      await driver.wait(until.elementLocated(By.id('linkButton3D_256')));
      await driver.findElement(By.id('linkButton3D_256')).click();
      await driver.wait(until.elementLocated(By.xpath('//*[@id="ui-id-4"]/div[3]/div/div[1]/span/a')))
      await driver.findElement(By.xpath('//*[@id="ui-id-4"]/div[3]/div/div[1]/span/a')).click();
      await driver.wait(until.elementLocated(By.xpath('//*[@id="ui-id-14"]/div[4]/div[4]/button')))
      await driver.findElement(By.xpath('//*[@id="ui-id-14"]/div[4]/div[4]/button')).click();
      await driver.wait(until.elementLocated(By.xpath('//*[@id="frmMasterInt"]/div[1]/div[2]/div[2]/div[2]/div[3]')))
      await driver.findElement(By.xpath('//*[@id="frmMasterInt"]/div[1]/div[2]/div[2]/div[2]/div[3]')).click();

    } catch (err) {
      console.log(err, 'error');
      return new CommonResponseModel(false, 0, err)
    }
  }

  // async getTradeLinkButtonBot() {
  //   try {
  //     const browser = await puppeteer.launch({ headless: false, args: ['--start-maximized'] });
  //     const page = await browser.newPage();
  //     await page.setViewport({ width: 1580, height: 900 });

  //     await page.goto('http://localhost:9002/api#/default/RLOrdersController_getTradeLinkPdf', {
  //       timeout: 100000,
  //       waitUntil: 'networkidle0',
  //     });

  //     await page.waitForSelector('.opblock-section .try-out__btn', { visible: true });
  //     await page.click('.opblock-section .try-out__btn');

  //     await page.waitForSelector('.btn.execute.opblock-control__btn', { visible: true });
  //     await page.click('.btn.execute.opblock-control__btn');

  //   } catch (error) {
  //     return new CommonResponseModel(false, 0, error);
  //   }
  // }





  @Cron('1 * * * *')
  async readPOPdfBot() {
    const browser = await puppeteer.launch({ headless: false, args: ['--start-maximized'] });

    try {
      const extractToPath = 'D:/RL-POs/RL-POs NEW/';
      const zipFilePath = 'C:/Users/Standby.it/Downloads/Ralph Lauren PO Report (PDF).zip/';
      const zip = new AdmZip(zipFilePath);
      zip.extractAllTo(extractToPath, true);

      fs.unlinkSync(zipFilePath);

      const page = await browser.newPage();
      await page.setViewport({ width: 1580, height: 900 });

      setTimeout(async () => {
        await page.goto('https://orders.shahiapps.in/', {
          timeout: 100000,
          waitUntil: 'networkidle0',
        })
      }, 10000);

      await page.waitForSelector('#login-form_username');
      await page.type('#login-form_username', 'RLadmin@gmail.com');

      await page.waitForSelector('#login-form_password');
      await page.type('#login-form_password', 'RLadmin');

      await page.click('button.ant-btn-primary');
      await page.waitForNavigation();

      const directoryPath = 'D:/RL-POs/RL-POs NEW';
      const sourceDirectory = 'D:/extractPath';
      const destinationDirectory = 'D:/RL-POs/RL-POs READ';

      const files = fs.readdirSync(directoryPath);
      // if (files.length === 0) {
      //   fs.unlinkSync(zipFilePath);
      //   return new CommonResponseModel(false, 0, "No Files Found");
      // }

      setTimeout(async () => {
        await page.goto('https://orders.shahiapps.in/#/ralph-lauren/pdf-upload/', {
          timeout: 10000,
          waitUntil: 'networkidle0',
        })
      })
      for (const file of files) {
        // console.log(file)
        // console.log('----------start-----------')
        await page.waitForSelector('input[type="file"]');
        const fileInput = await page.$('input[type="file"]');
        const filePath = path.join(directoryPath, file);
        await fileInput.uploadFile(filePath);
        await page.waitForTimeout(5000);
        // console.log('----------upload-----------')

        await page.waitForSelector('button.ant-btn-primary')
        await page.click('button.ant-btn-primary');
        await page.waitForTimeout(9000)
        // console.log('----------end-----------')
        const sourceFilePath = path.join(directoryPath, file);
        const destinationFilePath = path.join(destinationDirectory, file);
        fs.rename(sourceFilePath, destinationFilePath, async (err) => {
          if (err) {
            return new CommonResponseModel(false, 0, '');
          }
        })
        // console.log('----------the end-----------')
      }
    } catch (error) {
      // console.log(error)
      return new CommonResponseModel(false, 0, error)
    }
    finally {
      browser.close()
    }
  }

  @Cron('*/5 * * * *')
  async createCOline(req: any): Promise<CommonResponseModel> {
    const poDetails = await this.coLineRepo.getDataforCOLineCreation();
    if (!poDetails.length) {
      return new CommonResponseModel(false, 0, 'No CO-Line creation requests')
    }
    let driver = await new Builder().forBrowser(Browser.CHROME).build();
    try {
      await driver.get('http://intranetn.shahi.co.in:8080/ShahiExportIntranet/subApp?slNo=2447#');
      await driver.findElement(By.id('username')).sendKeys('99901347');
      await driver.findElement(By.id('password')).sendKeys('99901347');
      await driver.findElement(By.css('button.btn-primary')).click();
      await driver.get('http://intranetn.shahi.co.in:8080/ShahiExportIntranet/subApp?slNo=2447')
      const newPAge = await driver.executeScript(
        `javascript:openAccessPage('http://intranet.shahi.co.in:8080/IntraNet/CRMPRDNEW.jsp', 'CRM', '2448', 'R', '99901347', 'N', '20634576', 'null');`
      );
      const windowHandles = await driver.getAllWindowHandles()
      await driver.switchTo().window(windowHandles[1]);
      const frame = await driver.findElement(By.id('mainFrame'));
      await driver.switchTo().frame(frame)
      for (const po of poDetails) {
        const coLine = new CoLineRequest();
        let buyerValue1;
        let buyerValue2;
        let agent;
        let buyerAddress;
        let deliveryAddress;
        let pkgTerms;
        let paymentTerms;
        let styleNo;
        if (po.buyer === 'RL-U12') {
          const response = await this.getOrderDetails({ poNumber: po.buyer_po, poLine: po.line_item_no })
          const coData = response.data[0];
          console.log(coData)
          coLine.buyerPo = coData.buyerPo;
          const months = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
          ];
          const [day, monthAbbrev, year] = coData.deliveryDate.split('-');
          const month = (months.indexOf(monthAbbrev) + 1).toString().padStart(2, '0');
          coLine.deliveryDate = `${day}/${month}/${year}`
          // Create a Date object using the extracted components
          const inputDate = new Date(year, Number(month) - 1, day)
          // Calculate the date 7 days before the GAC date
          const sevenDaysBefore = new Date(inputDate);
          sevenDaysBefore.setDate(inputDate.getDate() - 7);
          const exFactoryDate = new Intl.DateTimeFormat('en-GB').format(sevenDaysBefore)
          coLine.exFactoryDate = exFactoryDate
          coLine.salesPrice = coData.salesPrice
          coLine.currency = coData.currency
          coLine.destinations = coData.destinations
          const parts = coData.destinations[0]?.name.split(',');
          const request = { country: parts[1].trim() }
          const address = await this.addressService.getAddressInfoByCountry(request);
          console.log(address)
          const addressData = address.data[0];
          styleNo = coData.styleNo
          buyerAddress = addressData?.buyerCode ? addressData?.buyerCode : 25;
          deliveryAddress = addressData?.deliveryCode
          buyerValue1 = "RAL-RALPH LAUREN"
          buyerValue2 = "RAL00001-RALPH LAUREN CORPORATION"
          agent = "-NA"
          pkgTerms = "STD-STD PACK"
          paymentTerms = "048-TT 15 DAYS"
        }
        const apps = await driver.wait(until.elementLocated(By.xpath('//*[@id="mainContainer"]/div[1]')));
        const allApps = await apps.findElements(By.tagName('span'));
        for (const app of allApps) {
          if ((await app.getAttribute('innerText')).includes('Style Order')) {
            await driver.executeScript('arguments[0].click();', app);
            break;
          }
        }
        await driver.wait(until.elementLocated(By.id('styleid2H')))
        await driver.findElement(By.id('styleid2H')).sendKeys(po.item_no);
        await driver.sleep(10000)
        await driver.wait(until.elementLocated(By.id('bgpset1')));
        const dropdownElement1 = await driver.findElement(By.id('bgpset1'));
        const dropdown1 = await driver.wait(until.elementIsVisible(dropdownElement1)).then(element => new Select(element))
        await dropdown1.selectByValue(buyerValue1)
        await driver.sleep(10000)
        await driver.wait(until.elementLocated(By.id('byr')));
        const dropdownElement2 = await driver.findElement(By.id('byr'));
        const dropdown2 = await driver.wait(until.elementIsVisible(dropdownElement2)).then(element => new Select(element))
        await dropdown2.selectByValue(buyerValue2)
        await driver.sleep(5000)
        await driver.wait(until.elementLocated(By.id('CreateOrderID')))
        await driver.sleep(3000)
        await driver.findElement(By.id('CreateOrderID')).click();
        await driver.wait(until.elementLocated(By.id('bpo')))
        await driver.findElement(By.id('bpo')).clear();
        await driver.findElement(By.id('bpo')).sendKeys(coLine.buyerPo);
        await driver.wait(until.elementLocated(By.id('bus')))
        await driver.findElement(By.id('bus')).clear();
        await driver.findElement(By.id('bus')).sendKeys(styleNo);
        //*[@id="form1"]/table/tbody/tr/td/table/tbody/tr[4]/td/table/tbody/tr/td/table/tbody/tr[5]/td[5]
        await driver.wait(until.elementLocated(By.id('agnt')));
        const agentDropDown = await driver.findElement(By.id('agnt'));
        await driver.executeScript(`arguments[0].value = '${agent}';`, agentDropDown)
        await driver.wait(until.elementLocated(By.name('dojo.EXFACTORYDATE')));
        await driver.findElement(By.name('dojo.EXFACTORYDATE')).clear();
        await driver.findElement(By.name('dojo.EXFACTORYDATE')).sendKeys(coLine.exFactoryDate);
        await driver.wait(until.elementLocated(By.name('dojo.delydt')));
        await driver.findElement(By.name('dojo.delydt')).clear();
        await driver.findElement(By.name('dojo.delydt')).sendKeys(coLine.deliveryDate);
        await driver.wait(until.elementLocated(By.name('byd')));
        const dropdown = await driver.findElement(By.name('byd'));
        const options = await dropdown.findElements(By.tagName('option'));
        const optionValues = [];
        for (const option of options) {
          const value = await option.getAttribute('value');
          optionValues.push(value);
        }
        const number = optionValues.find(value => value.includes(buyerAddress)); // give the dynamic value here
        await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);

        await driver.wait(until.elementLocated(By.xpath('//*[@id="cur"]')));
        const curDropdown = await driver.findElement(By.xpath('//*[@id="cur"]'));
        const cur = coLine.currency; // give the dynamic value here
        await driver.executeScript(`arguments[0].value = '${cur}';`, curDropdown);

        await driver.wait(until.elementLocated(By.xpath('//*[@id="price"]')));
        await driver.findElement(By.xpath('//*[@id="price"]')).clear();
        await driver.findElement(By.xpath('//*[@id="price"]')).sendKeys(coLine.salesPrice);

        await driver.wait(until.elementLocated(By.id('packtrm')));
        const pkgTermsDropDown = await driver.findElement(By.id('packtrm'));
        await driver.executeScript(`arguments[0].value = '${pkgTerms}';`, pkgTermsDropDown)
        await driver.wait(until.elementLocated(By.id('ptr')));
        const ptrDropDown = await driver.findElement(By.id('ptr'));
        await driver.executeScript(`arguments[0].value = '${paymentTerms}';`, ptrDropDown)
        await driver.sleep(10000)
        for (let dest of coLine.destinations) {
          const colorsContainer = await driver.wait(until.elementLocated(By.xpath('//*[@id="COContainer"]')));
          const colorsTabs = await colorsContainer.findElements(By.tagName('span'));
          // for (const tab of colorsTabs) {
          //   let destination;
          //   if (dest.name.toUpperCase().includes('EUROPE')) {
          //     destination = 'EUROPE'
          //   } else if (dest.name.toUpperCase().includes('USA')) {
          //     destination = 'USA'
          //   } else {
          //     destination = 'USA'
          //   }
          //   // if ((await tab.getAttribute('innerText')) == destination) {
          //   //   await driver.executeScript('arguments[0].click();', tab);
          //   //   for (let [colorIndex, color] of dest.colors.entries()) {
          //   //     for (let [sizeIndex, size] of color.sizes.entries()) {
          //   //       if (colorIndex === 0) {
          //   //         // Find all the labels in the second row.
          //   //         await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
          //   //         let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
          //   //         const fileteredElements: any[] = [];
          //   //         for (const labelElement of labelElements) {
          //   //           const ele = (await labelElement.getText())?.trim();
          //   //           ele.length > 0 ? fileteredElements.push(labelElement) : '';
          //   //         }
          //   //         let tabIndex = 1; // Default to 1 if no match
          //   //         const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
          //   //         const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
          //   //         await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
          //   //         const dropdown = await driver.findElement(By.id(`bydline/${string}`));
          //   //         const options = await dropdown.findElements(By.tagName('option'));
          //   //         const optionValues = [];
          //   //         for (const option of options) {
          //   //           const value = await option.getAttribute('value');
          //   //           optionValues.push(value);
          //   //         }
          //   //         const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
          //   //         await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
          //   //         // Find all the input fields in the first row.
          //   //         const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
          //   //         // Create a map of size labels to input fields.
          //   //         const sizeToInputMap = {};
          //   //         for (let i = 0; i < fileteredElements.length; i++) {
          //   //           const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString(); // Remove leading/trailing spaces
          //   //           if (label.length)
          //   //             sizeToInputMap[label] = inputElements[i];
          //   //         }
          //   //         const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
          //   //         if (inputField) {
          //   //           // Clear the existing value (if any) and fill it with the new price.
          //   //           await inputField.clear();
          //   //           await inputField.sendKeys(size.price);
          //   //         }
          //   //       }
          //   //       const inputId = `${size.name}:${color.name}:${dest.name}`.replace(/\*/g, '');
          //   //       const input = await driver.wait(until.elementLocated(By.id(inputId)))
          //   //       await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
          //   //     }
          //   //   }
          //   // } else 
          //   if ((await tab.getAttribute('innerText')) == destination) {
          //     await driver.executeScript('arguments[0].click();', tab);

          //     let tabIndex = 1; // Default to 1 if no match
          //     if (destination == 'USA') {
          //       tabIndex = 1
          //     } else if (destination = 'EUROPE') {
          //       tabIndex = 2
          //     }

          //     const sizesDivElementId = `nameDiv1${po.item_no}ZD00${tabIndex}`;
          //     const colorsDivElementId = `nameDiv3${po.item_no}ZD00${tabIndex}`;

          //     // parent div ids
          //     /**
          //      * to read sizes : nameDiv1359QZD001
          //      * to read colors : nameDiv3359QZD001   nameDiv3744QZD001
          //      * to read input fields: percentageDiv1359QZD001
          //      * 
          //      */
          //     const allSizes = [];
          //     console.log('---------------------------------------------------------------');
          //     await driver.wait(until.elementLocated(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`)));
          //     console.log("Read");

          //     // -----------------------   SIZES Reading from UI logic start ---------------
          //     // read all the sizes from the DOM
          //     let labelElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
          //     const totalElements = labelElements?.length;
          //     console.log('Total elements : ' + totalElements);
          //     labelElements.forEach(async r => {
          //       const label = (await r.getText()).trim().toUpperCase().toString();
          //       console.log(label,'LLLLLLL')
          //       allSizes.push(label);
          //     });
          //     console.log(allSizes)
          //     // Now iterate a random iteration of 10 loops to cover all sizes in the UI by doing a horizontal scroll
          //     let i = 1;
          //     while (i <= 10) {
          //       // Try to jump to right hand side of the div by 8 units. (Dont try more than that. Test and change this value if needed)
          //       const toJump = Math.min(i * 8, totalElements);
          //       const rightEle = driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${toJump}]`));
          //       // scroll the pointer to right side
          //       driver.executeScript("arguments[0].scrollIntoView()", rightEle);
          //       driver.sleep(1000);
          //       // read all the visible sizes from the DOM
          //       let currentUserVisbileElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
          //       // At some nth iteration, we can set all the sizes to the array once it is visible on the scope of selenium reader
          //       console.log("Iteration " + i + " : " + toJump + " --- " + currentUserVisbileElements.length);
          //       currentUserVisbileElements.forEach(async (r, index) => {
          //         if (allSizes[index] == '') {
          //           console.log(index, "index");
          //           const label = (await r.getText()).trim().toUpperCase().toString();
          //           allSizes[index] = label;
          //         }
          //       });
          //       console.log(allSizes);
          //       i++;
          //     }
          //     // construct a reverse mapping of size => column location for easy scrolling during qty input
          //     const sizeToDisplayRowColumnIndex = [];
          //     allSizes.forEach((size, i) => {
          //       sizeToDisplayRowColumnIndex[size] = i;
          //     })
          //     // -----------------------   SIZES Reading from UI logic END ---------------


          //     // ---------------------- COLOR GETTING LOGIC START -------------------------
          //     const colorsInTable = [];
          //     const colorsToDisplayRowColumnIndex = [];
          //     // get the total colors for the current PO from the UI
          //     const totalColorElements: any[] = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr`));
          //     let cc = 0;
          //     for (const r of totalColorElements) {
          //       // console.log("plesessssssssssssssssss")
          //       // scroll to the specific location in the screen to read the color 
          //       const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]`));
          //       // execute the scroll command
          //       await driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
          //       await driver.sleep(500);
          //       // now after scrolling, read the element from the DOM again. This time the selenium can read the value present in the DOM
          //       const sepcificRowColorEle = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]/td`));
          //       const displayingColor = (await sepcificRowColorEle[0]?.getText());
          //       // push the color to an array
          //       colorsInTable.push(displayingColor);
          //       cc++;
          //     }

          //     // now reverse map the color -> exact row index in the DOM
          //     colorsInTable.forEach((color, index) => {
          //       colorsToDisplayRowColumnIndex[color] = index;
          //     });
          //     // ---------------------- COLOR GETTING LOGIC END -------------------------

          //     //  console.log("ppppppppppppppp")

          //     // after reading all sizes data and colors date, get the scroll bar to the left again
          //     for (let [colorIndex, color] of dest.colors.entries()) {
          //       // for this specific color, scroll the window to the specific row where the color is visible
          //       const exactColorRowScrollLocation = colorsToDisplayRowColumnIndex[color.name] + 1;
          //       if (colorsToDisplayRowColumnIndex[color.name] == undefined || colorsToDisplayRowColumnIndex[color.name] == null) {
          //         break;
          //       }
          //       // console.log("testtttttttttttttttttttttt")
          //       const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${exactColorRowScrollLocation}]`));
          //       driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
          //       driver.sleep(500);
          //       for (let [sizeIndex, size] of color.sizes.entries()) {
          //         const exactSizeColumnScrollLocation = sizeToDisplayRowColumnIndex[size.name] + 1;
          //         if (!exactSizeColumnScrollLocation) {

          //           // const str = `NO matching Size found for color : ${color.name} and size :  ${size.name} `;
          //           const str = `NO matching Size found`;

          //           const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: str, isActive: false });
          //           await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
          //           return new CommonResponseModel(false, 0, 'NO matching Size found')
          //         }
          //         console.log(`size: ${size.name} and ${exactSizeColumnScrollLocation}`);
          //         console.log(sizesDivElementId, "sizesDivElementId")
          //         // Now for this specific size, scroll to the exact location in the interface where the size is visible
          //         const rightEle = await driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${exactSizeColumnScrollLocation}]`));
          //         driver.executeScript("arguments[0].scrollIntoView()", rightEle);
          //         driver.sleep(300);

          //         const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;

          //         const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
          //         await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
          //         const dropdown = await driver.findElement(By.id(`bydline/${string}`));
          //         const options = await dropdown.findElements(By.tagName('option'));
          //         const optionValues = [];
          //         for (const option of options) {
          //           const value = await option.getAttribute('value');
          //           optionValues.push(value);
          //         }
          //         const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
          //         await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
          //         // Find all the input fields in the first row.
          //         const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
          //         // Create a map of size labels to input fields.
          //         const sizeToInputMap = {};
          //         allSizes.forEach((s, index) => {
          //           sizeToInputMap[s] = inputElements[index];
          //         });
          //         // console.log('----------------------Size map done --------------------------');
          //         const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];

          //         if (inputField) {
          //           // Clear the existing value (if any) and fill it with the new price.
          //           await inputField.clear();
          //           await inputField.sendKeys(size.price);
          //         } else {
          //           const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: 'NO matching Size found', isActive: false });
          //           await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
          //           return new CommonResponseModel(false, 0, 'NO matching Size found')
          //         }

          //         const inputId = `${size.name}:${color.name}:${destination}`.replace(/\*/g, '');
          //         console.log(inputId, "inputId")
          //         const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
          //         console.log(input, "input")

          //         await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
          //       }
          //     }
          //   }
          // }

          for (const tab of colorsTabs) {
            if ((await tab.getAttribute('innerText')) == dest.name) {
              await driver.executeScript('arguments[0].click();', tab);
              for (let [colorIndex, color] of dest.colors.entries()) {
                for (let [sizeIndex, size] of color.sizes.entries()) {
                  if (colorIndex === 0) {
                    // Find all the labels in the second row.
                    await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                    let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                    const fileteredElements: any[] = [];
                    for (const labelElement of labelElements) {
                      const ele = (await labelElement.getText())?.trim();
                      ele.length > 0 ? fileteredElements.push(labelElement) : '';
                    }
                    let tabIndex = 1; // Default to 1 if no match
                    const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                    const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                    await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                    const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                    const options = await dropdown.findElements(By.tagName('option'));
                    const optionValues = [];
                    for (const option of options) {
                      const value = await option.getAttribute('value');
                      optionValues.push(value);
                    }
                    const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                    await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                    // Find all the input fields in the first row.
                    const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                    // Create a map of size labels to input fields.
                    const sizeToInputMap = {};
                    for (let i = 0; i < fileteredElements.length; i++) {
                      const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString(); // Remove leading/trailing spaces
                      if (label.length)
                        sizeToInputMap[label] = inputElements[i];
                    }
                    const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                    if (inputField) {
                      // Clear the existing value (if any) and fill it with the new price.
                      await inputField.clear();
                      await inputField.sendKeys(size.price);
                    }
                  }
                  const inputId = `${size.name}:${color.name.toString().toUpperCase().trim()}:${dest.name}`.replace(/\*/g, '');
                  const input = await driver.wait(until.elementLocated(By.id(inputId)))
                  await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
                }
              }
            }
            else if ((await tab.getAttribute('innerText')) == 'ASSORTED') {
              console.log(dest.colors, "color")
              console.log(dest.colors[0].sizes, "sizes")

              await driver.executeScript('arguments[0].click();', tab);

              const sizesDivElementId = `nameDiv1${po.item_no}ZD001`;
              const colorsDivElementId = `nameDiv3${po.item_no}ZD001`;


              // parent div ids
              /**
               * to read sizes : nameDiv1359QZD001
               * to read colors : nameDiv3359QZD001   nameDiv3744QZD001
               * to read input fields: percentageDiv1359QZD001
               * 
               */
              const allSizes = [];
              console.log('---------------------------------------------------------------');
              await driver.wait(until.elementLocated(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`)));
              console.log("Read");


              // -----------------------   SIZES Reading from UI logic start ---------------
              // read all the sizes from the DOM
              let labelElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
              const totalElements = labelElements?.length;
              console.log('Total elements : ' + totalElements);
              labelElements.forEach(async r => {
                const label = (await r.getText()).trim().toUpperCase().toString();
                allSizes.push(label);
              });
              // Now iterate a random iteration of 10 loops to cover all sizes in the UI by doing a horizontal scroll
              let i = 1;
              while (i <= 10) {
                // Try to jump to right hand side of the div by 8 units. (Dont try more than that. Test and change this value if needed)
                const toJump = Math.min(i * 8, totalElements);
                const rightEle = driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${toJump}]`));
                // scroll the pointer to right side
                driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                driver.sleep(1000);
                // read all the visible sizes from the DOM
                let currentUserVisbileElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
                // At some nth iteration, we can set all the sizes to the array once it is visible on the scope of selenium reader
                console.log("Iteration " + i + " : " + toJump + " --- " + currentUserVisbileElements.length);
                currentUserVisbileElements.forEach(async (r, index) => {
                  if (allSizes[index] == '') {
                    console.log(index, "index");
                    const label = (await r.getText()).trim().toUpperCase().toString();
                    allSizes[index] = label;
                  }
                });
                console.log(allSizes);
                i++;
              }
              // construct a reverse mapping of size => column location for easy scrolling during qty input
              const sizeToDisplayRowColumnIndex = [];
              allSizes.forEach((size, i) => {
                sizeToDisplayRowColumnIndex[size] = i;
              })
              // -----------------------   SIZES Reading from UI logic END ---------------


              // ---------------------- COLOR GETTING LOGIC START -------------------------
              const colorsInTable = [];
              const colorsToDisplayRowColumnIndex = [];
              // get the total colors for the current PO from the UI
              const totalColorElements: any[] = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr`));
              console.log('total colors : ' + totalColorElements.length);
              let cc = 0;
              for (const r of totalColorElements) {
                // console.log("plesessssssssssssssssss")
                // scroll to the specific location in the screen to read the color 
                const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]`));
                // execute the scroll command
                await driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
                await driver.sleep(500);
                // now after scrolling, read the element from the DOM again. This time the selenium can read the value present in the DOM
                const sepcificRowColorEle = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]/td`));
                console.log(sepcificRowColorEle, "sepcificRowColorEle");
                const displayingColor = (await sepcificRowColorEle[0]?.getText());
                // push the color to an array
                colorsInTable.push(displayingColor);
                cc++;
              }

              // now reverse map the color -> exact row index in the DOM
              colorsInTable.forEach((color, index) => {
                colorsToDisplayRowColumnIndex[color] = index;
              });
              // ---------------------- COLOR GETTING LOGIC END -------------------------

              //  console.log("ppppppppppppppp")
              for (let [colorIndex, color] of dest.colors.entries()) {
                // for this specific color, scroll the window to the specific row where the color is visible
                const exactColorRowScrollLocation = colorsToDisplayRowColumnIndex[color.name] + 1;
                if (colorsToDisplayRowColumnIndex[color.name] == undefined || colorsToDisplayRowColumnIndex[color.name] == null) {
                  // break;
                  const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: "Matching Color not found", isActive: false });
                  await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                  return new CommonResponseModel(false, 0, 'Matching Color not found')
                }
                const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${exactColorRowScrollLocation}]`));
                driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
                driver.sleep(500);
                try {
                  const saleInput = `${color.name.toUpperCase().toString().trim()}ASSORTED`;
                  console.log(saleInput, "saleInput")
                  const salePriceInput = await driver.findElement(By.id(saleInput), 10000);
                  await driver.findElement(By.id(saleInput)).sendKeys(`${color.sizes[0].price}`);
                } catch (error) {
                  console.error("Error finding sale price input:", error);
                  const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: "Matching Color not found", isActive: false });
                  await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                  // driver.quit()
                  return new CommonResponseModel(false, 0, 'Matching Color not found')
                }
                // for (let [sizeIndex, size] of color.sizes.entries()) {
                //   if (colorIndex === 0) {
                //     // console.log(sizeToDisplayRowColumnIndex)
                //     // console.log(size.name)
                //     const exactSizeColumnScrollLocation = sizeToDisplayRowColumnIndex[size.name] + 1;
                //     if (!exactSizeColumnScrollLocation) {
                //       const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: 'NO Matching Size found', isActive: false });
                //       await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                //       return new CommonResponseModel(false, 0, 'NO Matching Size found')
                //     }
                //     // console.log(`size: ${size.name} and ${exactSizeColumnScrollLocation}`);

                //     // Now for this specific size, scroll to the exact location in the interface where the size is visible
                //     const rightEle = await driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${exactSizeColumnScrollLocation}]`));
                //     driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                //     driver.sleep(1000);

                //     // Find all the labels in the second row.
                //     await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                //     let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                //     const fileteredElements: any[] = [];
                //     for (const labelElement of labelElements) {
                //       const ele = (await labelElement.getText())?.trim();
                //       ele.length > 0 ? fileteredElements.push(labelElement) : '';
                //     }
                //     let tabIndex = 1; // Default to 1 if no match
                //     // if ((await tab.getAttribute('innerText')) == 'ASSORTED') {
                //     //   tabIndex = 2
                //     // }
                //     const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                //     const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                //     await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                //     const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                //     const options = await dropdown.findElements(By.tagName('option'));
                //     const optionValues = [];
                //     for (const option of options) {
                //       const value = await option.getAttribute('value');
                //       optionValues.push(value);
                //     }
                //     const number = optionValues.find(value => {
                //       return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
                //     });
                //     console.log(number, "nummmm")
                //     // const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                //     await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                //     // Find all the input fields in the first row.
                //     const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                //     console.log(inputElements)
                //     // Create a map of size labels to input fields.
                //     const sizeToInputMap = {};
                //     console.log(fileteredElements, "///////////////")
                //     for (let i = 0; i < fileteredElements.length; i++) {
                //       const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString(); // Remove leading/trailing spaces
                //       console.log(label, "labellabellabellabel")
                //       if (label.length)
                //         console.log(inputElements[i], 'EEEEEEEEEEE')
                //       sizeToInputMap[label] = inputElements[i];
                //     }
                //     console.log(sizeToInputMap, 'SSSSSSSSSSSSSSSS')
                //     console.log(size.name, 'NNNNNNNNNNNNN')
                //     const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                //     console.log(inputField, "IIIIIIIIIIII")
                //     if (inputField) {
                //       // Clear the existing value (if any) and fill it with the new price.
                //       await inputField.clear();
                //       await inputField.sendKeys(size.price);
                //     } else {
                //       const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: 'NO Matching Size found', isActive: false });
                //       await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                //       return new CommonResponseModel(false, 0, 'NO Matching Size found')
                //     }
                //   }
                //   const inputId = `${size.name}:${color.name.toUpperCase().toString().trim()}:ASSORTED`.replace(/\*/g, '');
                //   console.log(inputId, "ppppp")
                //   const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
                //   await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
                // }
                for (let [sizeIndex, size] of color.sizes.entries()) {
                  // console.log(sizeToDisplayRowColumnIndex)
                  // console.log(size.name)
                  const exactSizeColumnScrollLocation = sizeToDisplayRowColumnIndex[size.name] + 1;
                  if (!exactSizeColumnScrollLocation) {
                    const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: 'NO Matching Size found', isActive: false });
                    await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                    return new CommonResponseModel(false, 0, 'NO Matching Size found')
                  }
                  // console.log(`size: ${size.name} and ${exactSizeColumnScrollLocation}`);

                  // Now for this specific size, scroll to the exact location in the interface where the size is visible
                  const rightEle = await driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${exactSizeColumnScrollLocation}]`));
                  driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                  driver.sleep(300);

                  // Find all the labels in the second row.
                  await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                  let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                  const fileteredElements: any[] = [];
                  for (const labelElement of labelElements) {
                    const ele = (await labelElement.getText())?.trim();
                    ele.length > 0 ? fileteredElements.push(labelElement) : '';
                  }
                  let tabIndex = 1; // Default to 1 if no match
                  // if ((await tab.getAttribute('innerText')) == 'ASSORTED') {
                  //   tabIndex = 2
                  // }
                  const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                  const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                  await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                  const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                  const options = await dropdown.findElements(By.tagName('option'));
                  const optionValues = [];
                  for (const option of options) {
                    const value = await option.getAttribute('value');
                    optionValues.push(value);
                  }
                  const number = optionValues.find(value => {
                    return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
                  });
                  // const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                  await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                  // Find all the input fields in the first row.
                  const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                  // Create a map of size labels to input fields.
                  const sizeToInputMap = {};
                  allSizes.forEach((s, index) => {
                    sizeToInputMap[s] = inputElements[index];
                  });
                  // console.log('----------------------Size map done --------------------------');

                  // const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                  // if (inputField) {
                  //   // // Clear the existing value (if any) and fill it with the new price.
                  //   await inputField.clear();
                  //   await inputField.sendKeys(size.price);
                  // } else {
                  //   const update = await this.coLineRepo.update({ poNumber: po.po_number, itemNo: po.item_no }, { status: 'Failed', errorMsg: 'NO matching Size found', isActive: false });
                  //   await this.updateCOLineStatus({ poNumber: po.po_number, itemNo: po.item_no, status: StatusEnum.FAILED })
                  //   return new CommonResponseModel(false, 0, 'NO matching Size found')
                  // }
                  // console.log(color.name,'COLOR NAME')
                  const inputId = `${size.name}:${color.name.toUpperCase().toString().trim()}:ASSORTED`.replace(/\*/g, '');
                  // console.log(inputId, "ppppp")
                  const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
                  await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
                }
              }
            }
            else if ((await tab.getAttribute('innerText')) == 'USA') {
              console.log(dest.colors, "color")
              console.log(dest.colors[0].sizes, "sizes")

              await driver.executeScript('arguments[0].click();', tab);

              const sizesDivElementId = `nameDiv1${po.item_no}ZD001`;
              const colorsDivElementId = `nameDiv3${po.item_no}ZD001`;


              // parent div ids
              /**
               * to read sizes : nameDiv1359QZD001
               * to read colors : nameDiv3359QZD001   nameDiv3744QZD001
               * to read input fields: percentageDiv1359QZD001
               * 
               */
              const allSizes = [];
              console.log('---------------------------------------------------------------');
              await driver.wait(until.elementLocated(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`)));
              console.log("Read");


              // -----------------------   SIZES Reading from UI logic start ---------------
              // read all the sizes from the DOM
              let labelElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
              const totalElements = labelElements?.length;
              console.log('Total elements : ' + totalElements);
              labelElements.forEach(async r => {
                const label = (await r.getText()).trim().toUpperCase().toString();
                allSizes.push(label);
              });
              // Now iterate a random iteration of 10 loops to cover all sizes in the UI by doing a horizontal scroll
              let i = 1;
              while (i <= 10) {
                // Try to jump to right hand side of the div by 8 units. (Dont try more than that. Test and change this value if needed)
                const toJump = Math.min(i * 8, totalElements);
                const rightEle = driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${toJump}]`));
                // scroll the pointer to right side
                driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                driver.sleep(1000);
                // read all the visible sizes from the DOM
                let currentUserVisbileElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
                // At some nth iteration, we can set all the sizes to the array once it is visible on the scope of selenium reader
                console.log("Iteration " + i + " : " + toJump + " --- " + currentUserVisbileElements.length);
                currentUserVisbileElements.forEach(async (r, index) => {
                  if (allSizes[index] == '') {
                    console.log(index, "index");
                    const label = (await r.getText()).trim().toUpperCase().toString();
                    allSizes[index] = label;
                  }
                });
                console.log(allSizes);
                i++;
              }
              // construct a reverse mapping of size => column location for easy scrolling during qty input
              const sizeToDisplayRowColumnIndex = [];
              allSizes.forEach((size, i) => {
                sizeToDisplayRowColumnIndex[size] = i;
              })
              // -----------------------   SIZES Reading from UI logic END ---------------


              // ---------------------- COLOR GETTING LOGIC START -------------------------
              const colorsInTable = [];
              const colorsToDisplayRowColumnIndex = [];
              // get the total colors for the current PO from the UI
              const totalColorElements: any[] = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr`));
              console.log('total colors : ' + totalColorElements.length);
              let cc = 0;
              for (const r of totalColorElements) {
                // console.log("plesessssssssssssssssss")
                // scroll to the specific location in the screen to read the color 
                const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]`));
                // execute the scroll command
                await driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
                await driver.sleep(500);
                // now after scrolling, read the element from the DOM again. This time the selenium can read the value present in the DOM
                const sepcificRowColorEle = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]/td`));
                console.log(sepcificRowColorEle, "sepcificRowColorEle");
                const displayingColor = (await sepcificRowColorEle[0]?.getText());
                // push the color to an array
                colorsInTable.push(displayingColor);
                cc++;
              }

              // now reverse map the color -> exact row index in the DOM
              colorsInTable.forEach((color, index) => {
                colorsToDisplayRowColumnIndex[color] = index;
              });
              // ---------------------- COLOR GETTING LOGIC END -------------------------

              //  console.log("ppppppppppppppp")
              for (let [colorIndex, color] of dest.colors.entries()) {
                // for this specific color, scroll the window to the specific row where the color is visible
                const exactColorRowScrollLocation = colorsToDisplayRowColumnIndex[color.name] + 1;
                if (colorsToDisplayRowColumnIndex[color.name] == undefined || colorsToDisplayRowColumnIndex[color.name] == null) {
                  // break;
                  const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: "Matching Color not found", isActive: false });
                  await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                  // driver.quit()
                  return new CommonResponseModel(false, 0, 'Matching Color not found')
                }
                const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${exactColorRowScrollLocation}]`));
                driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
                driver.sleep(500);
                try {
                  const saleInput = `${color.name.toUpperCase().toString().trim()}USA`;
                  console.log(saleInput, "saleInput")
                  const salePriceInput = await driver.findElement(By.id(saleInput), 10000);
                  await driver.findElement(By.id(saleInput)).sendKeys(`${color.sizes[0].price}`);
                } catch (error) {
                  console.error("Error finding sale price input:", error);
                  const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: "Matching Color not found", isActive: false });
                  await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                  // driver.quit()
                  return new CommonResponseModel(false, 0, 'Matching Color not found')
                }
                // for (let [sizeIndex, size] of color.sizes.entries()) {
                //   if (colorIndex === 0) {
                //     // console.log(sizeToDisplayRowColumnIndex)
                //     // console.log(size.name)
                //     const exactSizeColumnScrollLocation = sizeToDisplayRowColumnIndex[size.name] + 1;
                //     if (!exactSizeColumnScrollLocation) {
                //       const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: 'NO Matching Size found', isActive: false });
                //       await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                //       return new CommonResponseModel(false, 0, 'NO Matching Size found')
                //     }
                //     // console.log(`size: ${size.name} and ${exactSizeColumnScrollLocation}`);

                //     // Now for this specific size, scroll to the exact location in the interface where the size is visible
                //     const rightEle = await driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${exactSizeColumnScrollLocation}]`));
                //     driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                //     driver.sleep(1000);

                //     // Find all the labels in the second row.
                //     await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                //     let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                //     const fileteredElements: any[] = [];
                //     for (const labelElement of labelElements) {
                //       const ele = (await labelElement.getText())?.trim();
                //       ele.length > 0 ? fileteredElements.push(labelElement) : '';
                //     }
                //     let tabIndex = 1; // Default to 1 if no match
                //     // if ((await tab.getAttribute('innerText')) == 'USA') {
                //     //   tabIndex = 2
                //     // }
                //     const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                //     const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                //     await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                //     const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                //     const options = await dropdown.findElements(By.tagName('option'));
                //     const optionValues = [];
                //     for (const option of options) {
                //       const value = await option.getAttribute('value');
                //       optionValues.push(value);
                //     }
                //     const number = optionValues.find(value => {
                //       return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
                //     });
                //     console.log(number, "nummmm")
                //     // const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                //     await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                //     // Find all the input fields in the first row.
                //     const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                //     console.log(inputElements)
                //     // Create a map of size labels to input fields.
                //     const sizeToInputMap = {};
                //     console.log(fileteredElements, "///////////////")
                //     for (let i = 0; i < fileteredElements.length; i++) {
                //       const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString(); // Remove leading/trailing spaces
                //       console.log(label, "labellabellabellabel")
                //       if (label.length)
                //         console.log(inputElements[i], 'EEEEEEEEEEE')
                //       sizeToInputMap[label] = inputElements[i];
                //     }
                //     console.log(sizeToInputMap, 'SSSSSSSSSSSSSSSS')
                //     console.log(size.name, 'NNNNNNNNNNNNN')
                //     const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                //     console.log(inputField, "IIIIIIIIIIII")
                //     if (inputField) {
                //       // Clear the existing value (if any) and fill it with the new price.
                //       await inputField.clear();
                //       await inputField.sendKeys(size.price);
                //     } else {
                //       const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: 'NO Matching Size found', isActive: false });
                //       await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                //       return new CommonResponseModel(false, 0, 'NO Matching Size found')
                //     }
                //   }
                //   const inputId = `${size.name}:${color.name.toUpperCase().toString().trim()}:ASSORTED`.replace(/\*/g, '');
                //   console.log(inputId, "ppppp")
                //   const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
                //   await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
                // }
                for (let [sizeIndex, size] of color.sizes.entries()) {
                  // console.log(sizeToDisplayRowColumnIndex)
                  // console.log(size.name)
                  const exactSizeColumnScrollLocation = sizeToDisplayRowColumnIndex[size.name] + 1;
                  if (!exactSizeColumnScrollLocation) {
                    const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: 'NO Matching Size found', isActive: false });
                    await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                    return new CommonResponseModel(false, 0, 'NO Matching Size found')
                  }
                  // console.log(`size: ${size.name} and ${exactSizeColumnScrollLocation}`);

                  // Now for this specific size, scroll to the exact location in the interface where the size is visible
                  const rightEle = await driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${exactSizeColumnScrollLocation}]`));
                  driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                  driver.sleep(300);

                  // Find all the labels in the second row.
                  await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                  let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                  const fileteredElements: any[] = [];
                  for (const labelElement of labelElements) {
                    const ele = (await labelElement.getText())?.trim();
                    ele.length > 0 ? fileteredElements.push(labelElement) : '';
                  }
                  let tabIndex = 1; // Default to 1 if no match
                  // if ((await tab.getAttribute('innerText')) == 'USA') {
                  //   tabIndex = 2
                  // }
                  const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                  const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                  await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                  const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                  const options = await dropdown.findElements(By.tagName('option'));
                  const optionValues = [];
                  for (const option of options) {
                    const value = await option.getAttribute('value');
                    optionValues.push(value);
                  }
                  const number = optionValues.find(value => {
                    return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
                  });
                  // const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                  await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                  // Find all the input fields in the first row.
                  const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                  // Create a map of size labels to input fields.
                  const sizeToInputMap = {};
                  allSizes.forEach((s, index) => {
                    sizeToInputMap[s] = inputElements[index];
                  });
                  // console.log('----------------------Size map done --------------------------');

                  // const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                  // if (inputField) {
                  //   // // Clear the existing value (if any) and fill it with the new price.
                  //   await inputField.clear();
                  //   await inputField.sendKeys(size.price);
                  // } else {
                  //   const update = await this.coLineRepo.update({ poNumber: po.po_number, itemNo: po.item_no }, { status: 'Failed', errorMsg: 'NO matching Size found', isActive: false });
                  //   await this.updateCOLineStatus({ poNumber: po.po_number, itemNo: po.item_no, status: StatusEnum.FAILED })
                  //   return new CommonResponseModel(false, 0, 'NO matching Size found')
                  // }
                  // console.log(color.name,'COLOR NAME')
                  const inputId = `${size.name}:${color.name.toUpperCase().toString().trim()}:USA`.replace(/\*/g, '');
                  // console.log(inputId, "ppppp")
                  const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
                  await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
                }
              }
            }
            else if ((await tab.getAttribute('innerText')) == 'EUR') {
              console.log(dest.colors, "color")
              console.log(dest.colors[0].sizes, "sizes")

              await driver.executeScript('arguments[0].click();', tab);

              const sizesDivElementId = `nameDiv1${po.item_no}ZD001`;
              const colorsDivElementId = `nameDiv3${po.item_no}ZD001`;


              // parent div ids
              /**
               * to read sizes : nameDiv1359QZD001
               * to read colors : nameDiv3359QZD001   nameDiv3744QZD001
               * to read input fields: percentageDiv1359QZD001
               * 
               */
              const allSizes = [];
              console.log('---------------------------------------------------------------');
              await driver.wait(until.elementLocated(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`)));
              console.log("Read");


              // -----------------------   SIZES Reading from UI logic start ---------------
              // read all the sizes from the DOM
              let labelElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
              const totalElements = labelElements?.length;
              console.log('Total elements : ' + totalElements);
              labelElements.forEach(async r => {
                const label = (await r.getText()).trim().toUpperCase().toString();
                allSizes.push(label);
              });
              // Now iterate a random iteration of 10 loops to cover all sizes in the UI by doing a horizontal scroll
              let i = 1;
              while (i <= 10) {
                // Try to jump to right hand side of the div by 8 units. (Dont try more than that. Test and change this value if needed)
                const toJump = Math.min(i * 8, totalElements);
                const rightEle = driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${toJump}]`));
                // scroll the pointer to right side
                driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                driver.sleep(1000);
                // read all the visible sizes from the DOM
                let currentUserVisbileElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
                // At some nth iteration, we can set all the sizes to the array once it is visible on the scope of selenium reader
                console.log("Iteration " + i + " : " + toJump + " --- " + currentUserVisbileElements.length);
                currentUserVisbileElements.forEach(async (r, index) => {
                  if (allSizes[index] == '') {
                    console.log(index, "index");
                    const label = (await r.getText()).trim().toUpperCase().toString();
                    allSizes[index] = label;
                  }
                });
                console.log(allSizes);
                i++;
              }
              // construct a reverse mapping of size => column location for easy scrolling during qty input
              const sizeToDisplayRowColumnIndex = [];
              allSizes.forEach((size, i) => {
                sizeToDisplayRowColumnIndex[size] = i;
              })
              // -----------------------   SIZES Reading from UI logic END ---------------


              // ---------------------- COLOR GETTING LOGIC START -------------------------
              const colorsInTable = [];
              const colorsToDisplayRowColumnIndex = [];
              // get the total colors for the current PO from the UI
              const totalColorElements: any[] = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr`));
              console.log('total colors : ' + totalColorElements.length);
              let cc = 0;
              for (const r of totalColorElements) {
                // console.log("plesessssssssssssssssss")
                // scroll to the specific location in the screen to read the color 
                const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]`));
                // execute the scroll command
                await driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
                await driver.sleep(500);
                // now after scrolling, read the element from the DOM again. This time the selenium can read the value present in the DOM
                const sepcificRowColorEle = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]/td`));
                console.log(sepcificRowColorEle, "sepcificRowColorEle");
                const displayingColor = (await sepcificRowColorEle[0]?.getText());
                // push the color to an array
                colorsInTable.push(displayingColor);
                cc++;
              }

              // now reverse map the color -> exact row index in the DOM
              colorsInTable.forEach((color, index) => {
                colorsToDisplayRowColumnIndex[color] = index;
              });
              // ---------------------- COLOR GETTING LOGIC END -------------------------

              //  console.log("ppppppppppppppp")
              for (let [colorIndex, color] of dest.colors.entries()) {
                // for this specific color, scroll the window to the specific row where the color is visible
                const exactColorRowScrollLocation = colorsToDisplayRowColumnIndex[color.name] + 1;
                if (colorsToDisplayRowColumnIndex[color.name] == undefined || colorsToDisplayRowColumnIndex[color.name] == null) {
                  // break;
                  const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: "Matching Color not found", isActive: false });
                  await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                  // driver.quit()
                  return new CommonResponseModel(false, 0, 'Matching Color not found')
                }
                const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${exactColorRowScrollLocation}]`));
                driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
                driver.sleep(500);
                try {
                  const saleInput = `${color.name.toUpperCase().toString().trim()}EUR`;
                  console.log(saleInput, "saleInput")
                  const salePriceInput = await driver.findElement(By.id(saleInput), 10000);
                  await driver.findElement(By.id(saleInput)).sendKeys(`${color.sizes[0].price}`);
                } catch (error) {
                  console.error("Error finding sale price input:", error);
                  const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: "Matching Color not found", isActive: false });
                  await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                  // driver.quit()
                  return new CommonResponseModel(false, 0, 'Matching Color not found')
                }
                // for (let [sizeIndex, size] of color.sizes.entries()) {
                //   if (colorIndex === 0) {
                //     // console.log(sizeToDisplayRowColumnIndex)
                //     // console.log(size.name)
                //     const exactSizeColumnScrollLocation = sizeToDisplayRowColumnIndex[size.name] + 1;
                //     if (!exactSizeColumnScrollLocation) {
                //       const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: 'NO Matching Size found', isActive: false });
                //       await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                //       return new CommonResponseModel(false, 0, 'NO Matching Size found')
                //     }
                //     // console.log(`size: ${size.name} and ${exactSizeColumnScrollLocation}`);

                //     // Now for this specific size, scroll to the exact location in the interface where the size is visible
                //     const rightEle = await driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${exactSizeColumnScrollLocation}]`));
                //     driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                //     driver.sleep(1000);

                //     // Find all the labels in the second row.
                //     await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                //     let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                //     const fileteredElements: any[] = [];
                //     for (const labelElement of labelElements) {
                //       const ele = (await labelElement.getText())?.trim();
                //       ele.length > 0 ? fileteredElements.push(labelElement) : '';
                //     }
                //     let tabIndex = 1; // Default to 1 if no match
                //     // if ((await tab.getAttribute('innerText')) == 'USA') {
                //     //   tabIndex = 2
                //     // }
                //     const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                //     const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                //     await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                //     const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                //     const options = await dropdown.findElements(By.tagName('option'));
                //     const optionValues = [];
                //     for (const option of options) {
                //       const value = await option.getAttribute('value');
                //       optionValues.push(value);
                //     }
                //     const number = optionValues.find(value => {
                //       return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
                //     });
                //     console.log(number, "nummmm")
                //     // const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                //     await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                //     // Find all the input fields in the first row.
                //     const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                //     console.log(inputElements)
                //     // Create a map of size labels to input fields.
                //     const sizeToInputMap = {};
                //     console.log(fileteredElements, "///////////////")
                //     for (let i = 0; i < fileteredElements.length; i++) {
                //       const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString(); // Remove leading/trailing spaces
                //       console.log(label, "labellabellabellabel")
                //       if (label.length)
                //         console.log(inputElements[i], 'EEEEEEEEEEE')
                //       sizeToInputMap[label] = inputElements[i];
                //     }
                //     console.log(sizeToInputMap, 'SSSSSSSSSSSSSSSS')
                //     console.log(size.name, 'NNNNNNNNNNNNN')
                //     const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                //     console.log(inputField, "IIIIIIIIIIII")
                //     if (inputField) {
                //       // Clear the existing value (if any) and fill it with the new price.
                //       await inputField.clear();
                //       await inputField.sendKeys(size.price);
                //     } else {
                //       const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: 'NO Matching Size found', isActive: false });
                //       await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                //       return new CommonResponseModel(false, 0, 'NO Matching Size found')
                //     }
                //   }
                //   const inputId = `${size.name}:${color.name.toUpperCase().toString().trim()}:ASSORTED`.replace(/\*/g, '');
                //   console.log(inputId, "ppppp")
                //   const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
                //   await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
                // }
                for (let [sizeIndex, size] of color.sizes.entries()) {
                  // console.log(sizeToDisplayRowColumnIndex)
                  // console.log(size.name)
                  const exactSizeColumnScrollLocation = sizeToDisplayRowColumnIndex[size.name] + 1;
                  if (!exactSizeColumnScrollLocation) {
                    const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: 'NO Matching Size found', isActive: false });
                    await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                    return new CommonResponseModel(false, 0, 'NO Matching Size found')
                  }
                  // console.log(`size: ${size.name} and ${exactSizeColumnScrollLocation}`);

                  // Now for this specific size, scroll to the exact location in the interface where the size is visible
                  const rightEle = await driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${exactSizeColumnScrollLocation}]`));
                  driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                  driver.sleep(300);

                  // Find all the labels in the second row.
                  await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                  let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                  const fileteredElements: any[] = [];
                  for (const labelElement of labelElements) {
                    const ele = (await labelElement.getText())?.trim();
                    ele.length > 0 ? fileteredElements.push(labelElement) : '';
                  }
                  let tabIndex = 1; // Default to 1 if no match
                  // if ((await tab.getAttribute('innerText')) == 'EUR') {
                  //   tabIndex = 2
                  // }
                  const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                  const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                  await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                  const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                  const options = await dropdown.findElements(By.tagName('option'));
                  const optionValues = [];
                  for (const option of options) {
                    const value = await option.getAttribute('value');
                    optionValues.push(value);
                  }
                  const number = optionValues.find(value => {
                    return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
                  });
                  // const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                  await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                  // Find all the input fields in the first row.
                  const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                  // Create a map of size labels to input fields.
                  const sizeToInputMap = {};
                  allSizes.forEach((s, index) => {
                    sizeToInputMap[s] = inputElements[index];
                  });
                  // console.log('----------------------Size map done --------------------------');

                  // const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                  // if (inputField) {
                  //   // // Clear the existing value (if any) and fill it with the new price.
                  //   await inputField.clear();
                  //   await inputField.sendKeys(size.price);
                  // } else {
                  //   const update = await this.coLineRepo.update({ poNumber: po.po_number, itemNo: po.item_no }, { status: 'Failed', errorMsg: 'NO matching Size found', isActive: false });
                  //   await this.updateCOLineStatus({ poNumber: po.po_number, itemNo: po.item_no, status: StatusEnum.FAILED })
                  //   return new CommonResponseModel(false, 0, 'NO matching Size found')
                  // }
                  // console.log(color.name,'COLOR NAME')
                  const inputId = `${size.name}:${color.name.toUpperCase().toString().trim()}:EUR`.replace(/\*/g, '');
                  // console.log(inputId, "ppppp")
                  const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
                  await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
                }
              }
            }
            else if ((await tab.getAttribute('innerText')) == 'EUROPE') {
              console.log(dest.colors, "color")
              console.log(dest.colors[0].sizes, "sizes")

              await driver.executeScript('arguments[0].click();', tab);

              const sizesDivElementId = `nameDiv1${po.item_no}ZD001`;
              const colorsDivElementId = `nameDiv3${po.item_no}ZD001`;


              // parent div ids
              /**
               * to read sizes : nameDiv1359QZD001
               * to read colors : nameDiv3359QZD001   nameDiv3744QZD001
               * to read input fields: percentageDiv1359QZD001
               * 
               */
              const allSizes = [];
              console.log('---------------------------------------------------------------');
              await driver.wait(until.elementLocated(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`)));
              console.log("Read");


              // -----------------------   SIZES Reading from UI logic start ---------------
              // read all the sizes from the DOM
              let labelElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
              const totalElements = labelElements?.length;
              console.log('Total elements : ' + totalElements);
              labelElements.forEach(async r => {
                const label = (await r.getText()).trim().toUpperCase().toString();
                allSizes.push(label);
              });
              // Now iterate a random iteration of 10 loops to cover all sizes in the UI by doing a horizontal scroll
              let i = 1;
              while (i <= 10) {
                // Try to jump to right hand side of the div by 8 units. (Dont try more than that. Test and change this value if needed)
                const toJump = Math.min(i * 8, totalElements);
                const rightEle = driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${toJump}]`));
                // scroll the pointer to right side
                driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                driver.sleep(1000);
                // read all the visible sizes from the DOM
                let currentUserVisbileElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
                // At some nth iteration, we can set all the sizes to the array once it is visible on the scope of selenium reader
                console.log("Iteration " + i + " : " + toJump + " --- " + currentUserVisbileElements.length);
                currentUserVisbileElements.forEach(async (r, index) => {
                  if (allSizes[index] == '') {
                    console.log(index, "index");
                    const label = (await r.getText()).trim().toUpperCase().toString();
                    allSizes[index] = label;
                  }
                });
                console.log(allSizes);
                i++;
              }
              // construct a reverse mapping of size => column location for easy scrolling during qty input
              const sizeToDisplayRowColumnIndex = [];
              allSizes.forEach((size, i) => {
                sizeToDisplayRowColumnIndex[size] = i;
              })
              // -----------------------   SIZES Reading from UI logic END ---------------


              // ---------------------- COLOR GETTING LOGIC START -------------------------
              const colorsInTable = [];
              const colorsToDisplayRowColumnIndex = [];
              // get the total colors for the current PO from the UI
              const totalColorElements: any[] = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr`));
              console.log('total colors : ' + totalColorElements.length);
              let cc = 0;
              for (const r of totalColorElements) {
                // console.log("plesessssssssssssssssss")
                // scroll to the specific location in the screen to read the color 
                const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]`));
                // execute the scroll command
                await driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
                await driver.sleep(500);
                // now after scrolling, read the element from the DOM again. This time the selenium can read the value present in the DOM
                const sepcificRowColorEle = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]/td`));
                console.log(sepcificRowColorEle, "sepcificRowColorEle");
                const displayingColor = (await sepcificRowColorEle[0]?.getText());
                // push the color to an array
                colorsInTable.push(displayingColor);
                cc++;
              }

              // now reverse map the color -> exact row index in the DOM
              colorsInTable.forEach((color, index) => {
                colorsToDisplayRowColumnIndex[color] = index;
              });
              // ---------------------- COLOR GETTING LOGIC END -------------------------

              //  console.log("ppppppppppppppp")
              for (let [colorIndex, color] of dest.colors.entries()) {
                // for this specific color, scroll the window to the specific row where the color is visible
                const exactColorRowScrollLocation = colorsToDisplayRowColumnIndex[color.name] + 1;
                if (colorsToDisplayRowColumnIndex[color.name] == undefined || colorsToDisplayRowColumnIndex[color.name] == null) {
                  // break;
                  const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: "Matching Color not found", isActive: false });
                  await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                  // driver.quit()
                  return new CommonResponseModel(false, 0, 'Matching Color not found')
                }
                const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${exactColorRowScrollLocation}]`));
                driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
                driver.sleep(500);
                try {
                  const saleInput = `${color.name.toUpperCase().toString().trim()}EUROPE`;
                  console.log(saleInput, "saleInput")
                  const salePriceInput = await driver.findElement(By.id(saleInput), 10000);
                  await driver.findElement(By.id(saleInput)).sendKeys(`${color.sizes[0].price}`);
                } catch (error) {
                  console.error("Error finding sale price input:", error);
                  const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: "Matching Color not found", isActive: false });
                  await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                  // driver.quit()
                  return new CommonResponseModel(false, 0, 'Matching Color not found')
                }
                // for (let [sizeIndex, size] of color.sizes.entries()) {
                //   if (colorIndex === 0) {
                //     // console.log(sizeToDisplayRowColumnIndex)
                //     // console.log(size.name)
                //     const exactSizeColumnScrollLocation = sizeToDisplayRowColumnIndex[size.name] + 1;
                //     if (!exactSizeColumnScrollLocation) {
                //       const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: 'NO Matching Size found', isActive: false });
                //       await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                //       return new CommonResponseModel(false, 0, 'NO Matching Size found')
                //     }
                //     // console.log(`size: ${size.name} and ${exactSizeColumnScrollLocation}`);

                //     // Now for this specific size, scroll to the exact location in the interface where the size is visible
                //     const rightEle = await driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${exactSizeColumnScrollLocation}]`));
                //     driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                //     driver.sleep(1000);

                //     // Find all the labels in the second row.
                //     await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                //     let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                //     const fileteredElements: any[] = [];
                //     for (const labelElement of labelElements) {
                //       const ele = (await labelElement.getText())?.trim();
                //       ele.length > 0 ? fileteredElements.push(labelElement) : '';
                //     }
                //     let tabIndex = 1; // Default to 1 if no match
                //     // if ((await tab.getAttribute('innerText')) == 'EUROPE') {
                //     //   tabIndex = 2
                //     // }
                //     const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                //     const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                //     await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                //     const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                //     const options = await dropdown.findElements(By.tagName('option'));
                //     const optionValues = [];
                //     for (const option of options) {
                //       const value = await option.getAttribute('value');
                //       optionValues.push(value);
                //     }
                //     const number = optionValues.find(value => {
                //       return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
                //     });
                //     console.log(number, "nummmm")
                //     // const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                //     await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                //     // Find all the input fields in the first row.
                //     const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                //     console.log(inputElements)
                //     // Create a map of size labels to input fields.
                //     const sizeToInputMap = {};
                //     console.log(fileteredElements, "///////////////")
                //     for (let i = 0; i < fileteredElements.length; i++) {
                //       const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString(); // Remove leading/trailing spaces
                //       console.log(label, "labellabellabellabel")
                //       if (label.length)
                //         console.log(inputElements[i], 'EEEEEEEEEEE')
                //       sizeToInputMap[label] = inputElements[i];
                //     }
                //     console.log(sizeToInputMap, 'SSSSSSSSSSSSSSSS')
                //     console.log(size.name, 'NNNNNNNNNNNNN')
                //     const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                //     console.log(inputField, "IIIIIIIIIIII")
                //     if (inputField) {
                //       // Clear the existing value (if any) and fill it with the new price.
                //       await inputField.clear();
                //       await inputField.sendKeys(size.price);
                //     } else {
                //       const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: 'NO Matching Size found', isActive: false });
                //       await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                //       return new CommonResponseModel(false, 0, 'NO Matching Size found')
                //     }
                //   }
                //   const inputId = `${size.name}:${color.name.toUpperCase().toString().trim()}:ASSORTED`.replace(/\*/g, '');
                //   console.log(inputId, "ppppp")
                //   const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
                //   await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
                // }
                for (let [sizeIndex, size] of color.sizes.entries()) {
                  // console.log(sizeToDisplayRowColumnIndex)
                  // console.log(size.name)
                  const exactSizeColumnScrollLocation = sizeToDisplayRowColumnIndex[size.name] + 1;
                  if (!exactSizeColumnScrollLocation) {
                    const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: 'NO Matching Size found', isActive: false });
                    await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                    return new CommonResponseModel(false, 0, 'NO Matching Size found')
                  }
                  // console.log(`size: ${size.name} and ${exactSizeColumnScrollLocation}`);

                  // Now for this specific size, scroll to the exact location in the interface where the size is visible
                  const rightEle = await driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${exactSizeColumnScrollLocation}]`));
                  driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                  driver.sleep(300);

                  // Find all the labels in the second row.
                  await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                  let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                  const fileteredElements: any[] = [];
                  for (const labelElement of labelElements) {
                    const ele = (await labelElement.getText())?.trim();
                    ele.length > 0 ? fileteredElements.push(labelElement) : '';
                  }
                  let tabIndex = 1; // Default to 1 if no match
                  // if ((await tab.getAttribute('innerText')) == 'EUROPE') {
                  //   tabIndex = 2
                  // }
                  const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                  const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                  await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                  const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                  const options = await dropdown.findElements(By.tagName('option'));
                  const optionValues = [];
                  for (const option of options) {
                    const value = await option.getAttribute('value');
                    optionValues.push(value);
                  }
                  const number = optionValues.find(value => {
                    return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
                  });
                  // const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                  await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                  // Find all the input fields in the first row.
                  const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                  // Create a map of size labels to input fields.
                  const sizeToInputMap = {};
                  allSizes.forEach((s, index) => {
                    sizeToInputMap[s] = inputElements[index];
                  });
                  // console.log('----------------------Size map done --------------------------');

                  // const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                  // if (inputField) {
                  //   // // Clear the existing value (if any) and fill it with the new price.
                  //   await inputField.clear();
                  //   await inputField.sendKeys(size.price);
                  // } else {
                  //   const update = await this.coLineRepo.update({ poNumber: po.po_number, itemNo: po.item_no }, { status: 'Failed', errorMsg: 'NO matching Size found', isActive: false });
                  //   await this.updateCOLineStatus({ poNumber: po.po_number, itemNo: po.item_no, status: StatusEnum.FAILED })
                  //   return new CommonResponseModel(false, 0, 'NO matching Size found')
                  // }
                  // console.log(color.name,'COLOR NAME')
                  const inputId = `${size.name}:${color.name.toUpperCase().toString().trim()}:EUROPE`.replace(/\*/g, '');
                  // console.log(inputId, "ppppp")
                  const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
                  await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
                }
              }
            }
            else if ((await tab.getAttribute('innerText')) == 'US') {
              await driver.sleep(10000)

              await driver.executeScript('arguments[0].click();', tab);

              const sizesDivElementId = `nameDiv1${po.item_no}ZD001`;
              const colorsDivElementId = `nameDiv3${po.item_no}ZD001`;


              // parent div ids
              /**
               * to read sizes : nameDiv1359QZD001
               * to read colors : nameDiv3359QZD001   nameDiv3744QZD001
               * to read input fields: percentageDiv1359QZD001
               * 
               */
              const allSizes = [];
              console.log('---------------------------------------------------------------');
              await driver.wait(until.elementLocated(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`)));
              console.log("Read");


              // -----------------------   SIZES Reading from UI logic start ---------------
              // read all the sizes from the DOM
              let labelElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
              const totalElements = labelElements?.length;
              console.log('Total elements : ' + totalElements);
              labelElements.forEach(async r => {
                const label = (await r.getText()).trim().toUpperCase().toString();
                allSizes.push(label);
              });
              // Now iterate a random iteration of 10 loops to cover all sizes in the UI by doing a horizontal scroll
              let i = 1;
              while (i <= 10) {
                // Try to jump to right hand side of the div by 8 units. (Dont try more than that. Test and change this value if needed)
                const toJump = Math.min(i * 8, totalElements);
                const rightEle = driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${toJump}]`));
                // scroll the pointer to right side
                driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                driver.sleep(1000);
                // read all the visible sizes from the DOM
                let currentUserVisbileElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
                // At some nth iteration, we can set all the sizes to the array once it is visible on the scope of selenium reader
                console.log("Iteration " + i + " : " + toJump + " --- " + currentUserVisbileElements.length);
                currentUserVisbileElements.forEach(async (r, index) => {
                  if (allSizes[index] == '') {
                    console.log(index, "index");
                    const label = (await r.getText()).trim().toUpperCase().toString();
                    allSizes[index] = label;
                  }
                });
                console.log(allSizes);
                i++;
              }
              // construct a reverse mapping of size => column location for easy scrolling during qty input
              const sizeToDisplayRowColumnIndex = [];
              allSizes.forEach((size, i) => {
                sizeToDisplayRowColumnIndex[size] = i;
              })
              // -----------------------   SIZES Reading from UI logic END ---------------


              // ---------------------- COLOR GETTING LOGIC START -------------------------
              const colorsInTable = [];
              const colorsToDisplayRowColumnIndex = [];
              // get the total colors for the current PO from the UI
              const totalColorElements: any[] = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr`));
              console.log('total colors : ' + totalColorElements.length);
              let cc = 0;
              for (const r of totalColorElements) {
                // console.log("plesessssssssssssssssss")
                // scroll to the specific location in the screen to read the color 
                const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]`));
                // execute the scroll command
                await driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
                await driver.sleep(500);
                // now after scrolling, read the element from the DOM again. This time the selenium can read the value present in the DOM
                const sepcificRowColorEle = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]/td`));
                console.log(sepcificRowColorEle, "sepcificRowColorEle");
                const displayingColor = (await sepcificRowColorEle[0]?.getText());
                // push the color to an array
                colorsInTable.push(displayingColor);
                cc++;
              }

              // now reverse map the color -> exact row index in the DOM
              colorsInTable.forEach((color, index) => {
                colorsToDisplayRowColumnIndex[color] = index;
              });
              // ---------------------- COLOR GETTING LOGIC END -------------------------

              //  console.log("ppppppppppppppp")
              for (let [colorIndex, color] of dest.colors.entries()) {
                // for this specific color, scroll the window to the specific row where the color is visible
                const exactColorRowScrollLocation = colorsToDisplayRowColumnIndex[color.name] + 1;
                if (colorsToDisplayRowColumnIndex[color.name] == undefined || colorsToDisplayRowColumnIndex[color.name] == null) {
                  // break;
                  const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: "Matching Color not found", isActive: false });
                  await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                  // driver.quit()
                  return new CommonResponseModel(false, 0, 'Matching Color not found')
                }
                const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${exactColorRowScrollLocation}]`));
                driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
                driver.sleep(500);
                try {
                  const saleInput = `${color.name.toUpperCase().toString().trim()}US`;
                  console.log(saleInput, "saleInput")
                  const salePriceInput = await driver.findElement(By.id(saleInput), 10000);
                  await driver.findElement(By.id(saleInput)).sendKeys(`${color.sizes[0].price}`);
                } catch (error) {
                  console.error("Error finding sale price input:", error);
                  const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: "Matching Color not found", isActive: false });
                  await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                  // driver.quit()
                  return new CommonResponseModel(false, 0, 'Matching Color not found')
                }
                for (let [sizeIndex, size] of color.sizes.entries()) {
                  // console.log(sizeToDisplayRowColumnIndex)
                  // console.log(size.name)
                  const exactSizeColumnScrollLocation = sizeToDisplayRowColumnIndex[size.name] + 1;
                  if (!exactSizeColumnScrollLocation) {
                    const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: 'NO Matching Size found', isActive: false });
                    await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                    return new CommonResponseModel(false, 0, 'NO Matching Size found')
                  }
                  // console.log(`size: ${size.name} and ${exactSizeColumnScrollLocation}`);

                  // Now for this specific size, scroll to the exact location in the interface where the size is visible
                  const rightEle = await driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${exactSizeColumnScrollLocation}]`));
                  driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                  driver.sleep(300);

                  // Find all the labels in the second row.
                  await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                  let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                  const fileteredElements: any[] = [];
                  for (const labelElement of labelElements) {
                    const ele = (await labelElement.getText())?.trim();
                    ele.length > 0 ? fileteredElements.push(labelElement) : '';
                  }
                  let tabIndex = 1; // Default to 1 if no match
                  // if ((await tab.getAttribute('innerText')) == 'ASSORTED') {
                  //   tabIndex = 2
                  // }
                  const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                  const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                  await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                  const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                  const options = await dropdown.findElements(By.tagName('option'));
                  const optionValues = [];
                  for (const option of options) {
                    const value = await option.getAttribute('value');
                    optionValues.push(value);
                  }
                  const number = optionValues.find(value => {
                    return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
                  });
                  // const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                  await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                  // Find all the input fields in the first row.
                  const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                  // Create a map of size labels to input fields.
                  const sizeToInputMap = {};
                  allSizes.forEach((s, index) => {
                    sizeToInputMap[s] = inputElements[index];
                  });
                  // console.log('----------------------Size map done --------------------------');

                  // const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                  // if (inputField) {
                  //   // // Clear the existing value (if any) and fill it with the new price.
                  //   await inputField.clear();
                  //   await inputField.sendKeys(size.price);
                  // } else {
                  //   const update = await this.coLineRepo.update({ poNumber: po.po_number, itemNo: po.item_no }, { status: 'Failed', errorMsg: 'NO matching Size found', isActive: false });
                  //   await this.updateCOLineStatus({ poNumber: po.po_number, itemNo: po.item_no, status: StatusEnum.FAILED })
                  //   return new CommonResponseModel(false, 0, 'NO matching Size found')
                  // }
                  // console.log(color.name,'COLOR NAME')
                  const inputId = `${size.name}:${color.name.toUpperCase().toString().trim()}:US`.replace(/\*/g, '');
                  // console.log(inputId, "ppppp")
                  const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
                  await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
                }
              }

            }
            else if ((await tab.getAttribute('innerText')) == 'GERMANY') {
              console.log(dest.colors, "color")
              console.log(dest.colors[0].sizes, "sizes")

              await driver.executeScript('arguments[0].click();', tab);

              const sizesDivElementId = `nameDiv1${po.item_no}ZD001`;
              const colorsDivElementId = `nameDiv3${po.item_no}ZD001`;


              // parent div ids
              /**
               * to read sizes : nameDiv1359QZD001
               * to read colors : nameDiv3359QZD001   nameDiv3744QZD001
               * to read input fields: percentageDiv1359QZD001
               * 
               */
              const allSizes = [];
              console.log('---------------------------------------------------------------');
              await driver.wait(until.elementLocated(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`)));
              console.log("Read");


              // -----------------------   SIZES Reading from UI logic start ---------------
              // read all the sizes from the DOM
              let labelElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
              const totalElements = labelElements?.length;
              console.log('Total elements : ' + totalElements);
              labelElements.forEach(async r => {
                const label = (await r.getText()).trim().toUpperCase().toString();
                allSizes.push(label);
              });
              // Now iterate a random iteration of 10 loops to cover all sizes in the UI by doing a horizontal scroll
              let i = 1;
              while (i <= 10) {
                // Try to jump to right hand side of the div by 8 units. (Dont try more than that. Test and change this value if needed)
                const toJump = Math.min(i * 8, totalElements);
                const rightEle = driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${toJump}]`));
                // scroll the pointer to right side
                driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                driver.sleep(1000);
                // read all the visible sizes from the DOM
                let currentUserVisbileElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
                // At some nth iteration, we can set all the sizes to the array once it is visible on the scope of selenium reader
                console.log("Iteration " + i + " : " + toJump + " --- " + currentUserVisbileElements.length);
                currentUserVisbileElements.forEach(async (r, index) => {
                  if (allSizes[index] == '') {
                    console.log(index, "index");
                    const label = (await r.getText()).trim().toUpperCase().toString();
                    allSizes[index] = label;
                  }
                });
                console.log(allSizes);
                i++;
              }
              // construct a reverse mapping of size => column location for easy scrolling during qty input
              const sizeToDisplayRowColumnIndex = [];
              allSizes.forEach((size, i) => {
                sizeToDisplayRowColumnIndex[size] = i;
              })
              // -----------------------   SIZES Reading from UI logic END ---------------


              // ---------------------- COLOR GETTING LOGIC START -------------------------
              const colorsInTable = [];
              const colorsToDisplayRowColumnIndex = [];
              // get the total colors for the current PO from the UI
              const totalColorElements: any[] = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr`));
              console.log('total colors : ' + totalColorElements.length);
              let cc = 0;
              for (const r of totalColorElements) {
                // console.log("plesessssssssssssssssss")
                // scroll to the specific location in the screen to read the color 
                const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]`));
                // execute the scroll command
                await driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
                await driver.sleep(500);
                // now after scrolling, read the element from the DOM again. This time the selenium can read the value present in the DOM
                const sepcificRowColorEle = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]/td`));
                console.log(sepcificRowColorEle, "sepcificRowColorEle");
                const displayingColor = (await sepcificRowColorEle[0]?.getText());
                // push the color to an array
                colorsInTable.push(displayingColor);
                cc++;
              }

              // now reverse map the color -> exact row index in the DOM
              colorsInTable.forEach((color, index) => {
                colorsToDisplayRowColumnIndex[color] = index;
              });
              // ---------------------- COLOR GETTING LOGIC END -------------------------

              //  console.log("ppppppppppppppp")
              for (let [colorIndex, color] of dest.colors.entries()) {
                // for this specific color, scroll the window to the specific row where the color is visible
                const exactColorRowScrollLocation = colorsToDisplayRowColumnIndex[color.name] + 1;
                if (colorsToDisplayRowColumnIndex[color.name] == undefined || colorsToDisplayRowColumnIndex[color.name] == null) {
                  // break;
                  const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: "Matching Color not found", isActive: false });
                  await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                  // driver.quit()
                  return new CommonResponseModel(false, 0, 'Matching Color not found')
                }
                const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${exactColorRowScrollLocation}]`));
                driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
                driver.sleep(500);
                try {
                  const saleInput = `${color.name.toUpperCase().toString().trim()}GERMANY`;
                  console.log(saleInput, "saleInput")
                  const salePriceInput = await driver.findElement(By.id(saleInput), 10000);
                  await driver.findElement(By.id(saleInput)).sendKeys(`${color.sizes[0].price}`);
                } catch (error) {
                  console.error("Error finding sale price input:", error);
                  const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: "Matching Color not found", isActive: false });
                  await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                  // driver.quit()
                  return new CommonResponseModel(false, 0, 'Matching Color not found')
                }
                // for (let [sizeIndex, size] of color.sizes.entries()) {
                //   if (colorIndex === 0) {
                //     // console.log(sizeToDisplayRowColumnIndex)
                //     // console.log(size.name)
                //     const exactSizeColumnScrollLocation = sizeToDisplayRowColumnIndex[size.name] + 1;
                //     if (!exactSizeColumnScrollLocation) {
                //       const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: 'NO Matching Size found', isActive: false });
                //       await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                //       return new CommonResponseModel(false, 0, 'NO Matching Size found')
                //     }
                //     // console.log(`size: ${size.name} and ${exactSizeColumnScrollLocation}`);

                //     // Now for this specific size, scroll to the exact location in the interface where the size is visible
                //     const rightEle = await driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${exactSizeColumnScrollLocation}]`));
                //     driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                //     driver.sleep(1000);

                //     // Find all the labels in the second row.
                //     await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                //     let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                //     const fileteredElements: any[] = [];
                //     for (const labelElement of labelElements) {
                //       const ele = (await labelElement.getText())?.trim();
                //       ele.length > 0 ? fileteredElements.push(labelElement) : '';
                //     }
                //     let tabIndex = 1; // Default to 1 if no match
                //     // if ((await tab.getAttribute('innerText')) == 'ASSORTED') {
                //     //   tabIndex = 2
                //     // }
                //     const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                //     const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                //     await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                //     const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                //     const options = await dropdown.findElements(By.tagName('option'));
                //     const optionValues = [];
                //     for (const option of options) {
                //       const value = await option.getAttribute('value');
                //       optionValues.push(value);
                //     }
                //     const number = optionValues.find(value => {
                //       return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
                //     });
                //     console.log(number, "nummmm")
                //     // const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                //     await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                //     // Find all the input fields in the first row.
                //     const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                //     console.log(inputElements)
                //     // Create a map of size labels to input fields.
                //     const sizeToInputMap = {};
                //     console.log(fileteredElements, "///////////////")
                //     for (let i = 0; i < fileteredElements.length; i++) {
                //       const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString(); // Remove leading/trailing spaces
                //       console.log(label, "labellabellabellabel")
                //       if (label.length)
                //         console.log(inputElements[i], 'EEEEEEEEEEE')
                //       sizeToInputMap[label] = inputElements[i];
                //     }
                //     console.log(sizeToInputMap, 'SSSSSSSSSSSSSSSS')
                //     console.log(size.name, 'NNNNNNNNNNNNN')
                //     const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                //     console.log(inputField, "IIIIIIIIIIII")
                //     if (inputField) {
                //       // Clear the existing value (if any) and fill it with the new price.
                //       await inputField.clear();
                //       await inputField.sendKeys(size.price);
                //     } else {
                //       const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: 'NO Matching Size found', isActive: false });
                //       await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                //       return new CommonResponseModel(false, 0, 'NO Matching Size found')
                //     }
                //   }
                //   const inputId = `${size.name}:${color.name.toUpperCase().toString().trim()}:ASSORTED`.replace(/\*/g, '');
                //   console.log(inputId, "ppppp")
                //   const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
                //   await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
                // }
                for (let [sizeIndex, size] of color.sizes.entries()) {
                  // console.log(sizeToDisplayRowColumnIndex)
                  // console.log(size.name)
                  const exactSizeColumnScrollLocation = sizeToDisplayRowColumnIndex[size.name] + 1;
                  if (!exactSizeColumnScrollLocation) {
                    const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: 'NO Matching Size found', isActive: false });
                    await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
                    return new CommonResponseModel(false, 0, 'NO Matching Size found')
                  }
                  // console.log(`size: ${size.name} and ${exactSizeColumnScrollLocation}`);

                  // Now for this specific size, scroll to the exact location in the interface where the size is visible
                  const rightEle = await driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${exactSizeColumnScrollLocation}]`));
                  driver.executeScript("arguments[0].scrollIntoView()", rightEle);
                  driver.sleep(300);

                  // Find all the labels in the second row.
                  await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                  let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                  const fileteredElements: any[] = [];
                  for (const labelElement of labelElements) {
                    const ele = (await labelElement.getText())?.trim();
                    ele.length > 0 ? fileteredElements.push(labelElement) : '';
                  }
                  let tabIndex = 1; // Default to 1 if no match
                  // if ((await tab.getAttribute('innerText')) == 'ASSORTED') {
                  //   tabIndex = 2
                  // }
                  const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                  const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                  await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                  const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                  const options = await dropdown.findElements(By.tagName('option'));
                  const optionValues = [];
                  for (const option of options) {
                    const value = await option.getAttribute('value');
                    optionValues.push(value);
                  }
                  const number = optionValues.find(value => {
                    return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
                  });
                  // const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                  await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                  // Find all the input fields in the first row.
                  const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                  // Create a map of size labels to input fields.
                  const sizeToInputMap = {};
                  allSizes.forEach((s, index) => {
                    sizeToInputMap[s] = inputElements[index];
                  });
                  // console.log('----------------------Size map done --------------------------');

                  // const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                  // if (inputField) {
                  //   // // Clear the existing value (if any) and fill it with the new price.
                  //   await inputField.clear();
                  //   await inputField.sendKeys(size.price);
                  // } else {
                  //   const update = await this.coLineRepo.update({ poNumber: po.po_number, itemNo: po.item_no }, { status: 'Failed', errorMsg: 'NO matching Size found', isActive: false });
                  //   await this.updateCOLineStatus({ poNumber: po.po_number, itemNo: po.item_no, status: StatusEnum.FAILED })
                  //   return new CommonResponseModel(false, 0, 'NO matching Size found')
                  // }
                  // console.log(color.name,'COLOR NAME')
                  const inputId = `${size.name}:${color.name.toUpperCase().toString().trim()}:GERMANY`.replace(/\*/g, '');
                  // console.log(inputId, "ppppp")
                  const input = await driver.wait(until.elementLocated(By.id(inputId)), 10000)
                  await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
                }
              }
            }
          }
        }
        await driver.sleep(10000)
        const element = await driver.findElement(By.id('OrderCreateID')).click();
        await driver.wait(until.alertIsPresent(), 10000);
        // Switch to the alert and accept it (click "OK")
        const alert = await driver.switchTo().alert();
        await alert.accept();
        if (await this.isAlertPresent(driver)) {
          const alert = await driver.switchTo().alert();
          const alertText = await alert.getText();
          const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', errorMsg: alertText, isActive: false });
          await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
          await alert.accept();
          await driver.sleep(5000)
          await driver.navigate().refresh();
          await driver.quit();
          return new CommonResponseModel(false, 0, alertText)
        } else {
          await driver.sleep(10000)
          await driver.wait(until.elementLocated(By.xpath('//*[@id="orno"]')), 10000);
          const coNoElement = await driver.findElement(By.xpath('//*[@id="orno"]'));
          const coNo = await coNoElement.getAttribute('value');
          await driver.sleep(5000)
          const currentDate = new Date();
          const day = currentDate.getDate().toString().padStart(2, '0');
          const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(currentDate);
          const year = currentDate.getFullYear().toString().slice(-2);
          const currentDateFormatted = `${day}-${month}-${year}`;
          if (coNo) {
            const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { coNumber: coNo, status: 'Success', coDate: currentDateFormatted, errorMsg: "-" });
            await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.SUCCESS })
            // await driver.navigate().refresh();
            await driver.sleep(10000)
            return new CommonResponseModel(true, 1, `COline created successfully`)
          } else {
            const update = await this.coLineRepo.update({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no }, { status: 'Failed', isActive: false });
            await this.updateCOLineStatus({ buyerPo: po.buyer_po, lineItemNo: po.line_item_no, itemStatus: ItemStatusEnum.FAILED })
            // await driver.navigate().refresh();
            await driver.sleep(10000)
          }
        }
      }
      return new CommonResponseModel(true, 1, `COline created successfully`)
    }
    catch (error) {
      console.log(error, 'error');
      const update = await this.coLineRepo.update({ buyerPo: poDetails[0].buyer_po, lineItemNo: poDetails[0].line_item_no }, { status: 'Failed', errorMsg: error.name, isActive: false });
      await this.updateCOLineStatus({ buyerPo: poDetails[0].buyer_po, lineItemNo: poDetails[0].line_item_no, itemStatus: ItemStatusEnum.FAILED })
      const emailBot = await this.getCoLineDataAndSendEmail()
      console.log(emailBot, "emailBot")
      return new CommonResponseModel(false, 0, error.name)
    }
    finally {
      driver.quit()
    }
  }


  async isAlertPresent(driver) {
    try {
      await driver.switchTo().alert();
      return true;
    } catch (e) {
      return false;
    }
  }

  async getCoLine(req?: coLineRequest): Promise<CommonResponseModel> {
    const data = await this.coLineRepo.getCoLineData(req)
    if (data.length > 0)
      return new CommonResponseModel(true, 1, 'data retrived', data)
    else
      return new CommonResponseModel(false, 0, 'No data found');
  }

  async getBuyerPo(): Promise<CommonResponseModel> {
    const data = await this.coLineRepo.getBuyerPo()
    if (data.length > 0)
      return new CommonResponseModel(true, 1, 'data retrived', data)
    else
      return new CommonResponseModel(false, 0, 'No data found');
  }

  async getBuyerPoNumber(): Promise<CommonResponseModel> {
    const data = await this.pdfrepo.getBuyerPoNumber()
    if (data.length > 0)
      return new CommonResponseModel(true, 1, 'data retrived', data)
    else
      return new CommonResponseModel(false, 0, 'No data found');
  }


  async getColineItem(): Promise<CommonResponseModel> {
    const data = await this.coLineRepo.getItem()
    if (data.length > 0)
      return new CommonResponseModel(true, 1, 'data retrived', data)
    else
      return new CommonResponseModel(false, 0, 'No data found');
  }

  async getColineOrderNo(): Promise<CommonResponseModel> {
    const data = await this.coLineRepo.getOrderNumber()
    if (data.length > 0)
      return new CommonResponseModel(true, 1, 'data retrived', data)
    else
      return new CommonResponseModel(false, 0, 'No data found');
  }

  async updatePath(req: any, poNumber: string, filePath: string, filename: string, mimetype: string): Promise<CommonResponseModel> {
    const entity = new PdfFileUploadEntity();
    const match = filename.match(/(\d+)_v/);
    const poNumberFromFileName = match ? match[1] : null;
    entity.poNumber = poNumberFromFileName;
    entity.pdfFileName = filename;
    entity.filePath = filePath;
    entity.fileType = mimetype;
    entity.fileData = JSON.stringify(req)
    entity.fileData = req;
    console.log(entity.fileData, "fileData")

    const file = await this.pdfrepo.findOne({ where: { pdfFileName: filePath } })
    if (file) {
      return new CommonResponseModel(false, 0, 'File with same name already uploaded');
    } else {
      const save = await this.pdfrepo.save(entity)
      if (save) {
        return new CommonResponseModel(true, 1, 'uploaded successfully', save);
      }
      else {
        return new CommonResponseModel(false, 0, 'uploaded failed');
      }
    }
  }

  // async updateDownloadStatus(
  //   req: StatusDto
  // ): Promise<CommonResponseModel> {
  //   try {
  //     const update = await this.pdfrepo.update(
  //       { id: req.id }, 
  //       { status: req.status }
  //     );
  //     if (update.affected > 0) {
  //       return new CommonResponseModel(
  //         true,
  //         1,
  //         "Status Updated SuccessFully"
  //       );
  //     } else {
  //       return new CommonResponseModel(
  //         false,
  //         0,
  //         "Something went wrong",
  //         []
  //       );
  //     }   } catch (error) {
  //       return error;
  //     }
  //   }

  async getPoNumber(): Promise<CommonResponseModel> {
    const data = await this.rlOrdersRepo.getpoNumber()
    if (data.length > 0)
      return new CommonResponseModel(true, 1, 'data retrived', data)
    else
      return new CommonResponseModel(false, 0, 'No data found');
  }




  async revertProjectionFileData(req: OrderRevertModel): Promise<CommonResponseModel> {
    console.log(req, "ooojjjj")
    if (req) {

      const latestFileId = await this.pdfrepo.update({ id: req.pdfId, poNumber: req.poNumber }, { isActive: false });

      if (!latestFileId.affected) {
        return new CommonResponseModel(false, 0, 'Something went wrong in File update')
      }
      // else{
      //   return new CommonResponseModel(true, 0, 'File update')

      // }
    }
    if (req) {

      const childData = await this.orderChildRepo.find({ where: { poNumber: req.poNumber }, order: { ordersChildId: 'DESC' }, take: 1, skip: 1 })
      console.log(childData, "kkk")
      const deleteChildData = await this.orderChildRepo.delete({ poNumber: childData[0].poNumber, poVersion: childData[0].poVersion })
      const deleteOrdersData = await this.rlOrdersRepo.delete({ poNumber: childData[0].poNumber, versionFlag: 1 })


    }


    // const updatedData = await manager.getRepository(OrdersChildEntity).find({
    //     select: ['fileId'],
    //     order: { id: 'DESC' }, take: 1
    // })

    const updatedData = await this.orderChildRepo.find({
      where: {
        poNumber: req.poNumber
      }, order: { ordersChildId: 'DESC' }, take: 1, skip: 1
    })

    const flag = new Set()
    let data = []
    if (updatedData.length > 0) {
      // data = await manager.getRepository(OrdersChildEntity).find({ where: { fileId: updatedData[0]?.fileId } })
      data = await this.orderChildRepo.find({ where: { ordersChildId: updatedData[0]?.ordersChildId } })
      // this.ordersChildRepo.find({
      //     where: { fileId: updatedData[0]?.fileId },
      //     // relations: ['orders']
      // })
    } else {
      flag.add(true)
    }

    if (data.length > 0) {

      for (const dtoData of data) {
        // const prodPlanId = new OrdersEntity();
        // prodPlanId.productionPlanId = dtoData.orders.productionPlanId
        // const updateOrder = await manager.getRepository(OrdersEntity).update({ orderPlanNumber: dtoData.orderPlanNumber }, {
        //     year: dtoData.year, planningSsn: dtoData.planningSsn, biz: dtoData.biz, coreCategory: dtoData.coreCategory, planningSum: dtoData.planningSum, coeff: dtoData.coeff, publishFlagForFactory: dtoData.publishFlagForFactory, orderPlanQty: dtoData.orderPlanQty, orderPlanQtyCoeff: dtoData.orderPlanQtyCoeff, prodPlanType: dtoData.prodPlanType, wh: dtoData.wh, exfEtd: dtoData.exfEtd, etdWh: dtoData.etdWh, sample: dtoData.sample, version: dtoData.version, fileId: dtoData.fileId, updatedUser: dtoData.createdUser
        // })

        // if (updateOrder.affected) {
        //     flag.add(true)
        // } else {
        //     flag.add(false)
        //     // await manager.releaseTransaction()
        //     return new CommonResponseModel(false, 0, 'Something went wrong in order update', updateOrder)
        // }
      }
    } else {
      flag.add(true)
    }
    if (flag.has(true)) {
      // await manager.completeTransaction()
      return new CommonResponseModel(true, 1, 'File Reverted Successfully')
    } else {
      // await manager.releaseTransaction()
      return new CommonResponseModel(false, 0, 'failed to revert file data')
    }
  }

  async updateItemNo(req: ItemNoDtos): Promise<CommonResponseModel> {
    console.log(req, "reqq");
    try {
      const update = await this.coLineRepo.update(
        { id: Number(req.id) },
        { itemNo: req.itemNo }
      );

      if (update) {
        return new CommonResponseModel(true, 1, "Update Successfully");
      } else {
        return new CommonResponseModel(false, 0, "Something Went Wrong", []);
      }
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error Occurred While Updating ", error);
    }
  }


  async deleteCoLine(req: ItemNoDtos): Promise<CommonResponseModel> {
    console.log(req, "reqq");
    try {
      const deletedItem = await this.coLineRepo.delete({ id: Number(req.id) });

      if (deletedItem && deletedItem.affected) {
        return new CommonResponseModel(true, 1, "Deleted Successfully");
      } else {
        return new CommonResponseModel(false, 0, "Something Went Wrong", []);
      }
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error Occurred While Deleting", error);
    }
  }

  async updateCOLineStatus(req: any): Promise<CommonResponseModel> {
    const update = await this.rlOrdersRepo.update({
      poNumber: req.buyerPo, poItem: req.lineItemNo
    }, {
      itemStatus: req.itemStatus
    })
    if (update.affected) {
      return new CommonResponseModel(true, 1, 'Success')
    } else {
      return new CommonResponseModel(false, 0, 'Failed')
    }
  }


  async updateStatusInOrder(req: any): Promise<CommonResponseModel> {
    try {

      const update = await this.rlOrdersRepo.update({
        poNumber: req.poNumber, poItem: req.poLine
      }, {
        itemStatus: ItemStatusEnum.OPEN
      })

      if (update.affected) {
        return new CommonResponseModel(true, 1, 'Updated Successfully')
      } else {
        return new CommonResponseModel(false, 0, 'Failed')
      }

    } catch (error) {
      return new CommonResponseModel(false, 0, "Error Occurred", error);
    }
  }


  // async getCoLineDataAndSendEmail(): Promise<CommonResponseModel> {
  //   const recipientEmail = 'jaswanthpappala3@gmail.com';
  //   const ccEmails = ['saiprakash.katiki@gmail.com', 'santhosh.palaksha@shahi.co.in', 'manu.gupta@shahi.co.in', 'pradeep@schemaxtech.com', 'sujatha@schemaxtech.com'];
  //   const response = await this.coLineRepo.getCoLineData();
  //   const data = response;

  //   const failedPoNumbersData = [];
  //   data.forEach(po => {
  //     if (po.po_number && (po.status === 'Failed')) {
  //       failedPoNumbersData.push(po.po_number);
  //     }
  //   });
  //   const coLineFailedData = data.filter(item => item.status === 'Failed');
  //   if (coLineFailedData.length > 0) {
  //     const errorMessage = coLineFailedData.map(item => `
  //         PO Number: ${item.buyer_po}
  //         Buyer Name: RL
  //         PO Line: ${item.line_item_no}
  //         Item No: ${item.item_no}
  //         CO Number: ${item.co_number}
  //         CO Date: ${item.co_date}
  //         Status: ${item.status}
  //         Message: ${item.error_msg}
  //       `).join('\n\n');

  //     const transporter = nodemailer.createTransport({
  //       host: 'smtp.gmail.com',
  //       port: 587,
  //       secure: false,
  //       auth: {
  //         user: 'jayanthpappala3@gmail.com',
  //         pass: 'pohe kref wtua gijk'
  //       }
  //     });

  //     const mailOptions = {
  //       from: 'jayanthpappala3@gmail.com',
  //       to: recipientEmail,
  //       cc: ccEmails,
  //       subject: 'RL CO Line Failed Status',
  //       text: `Dear User,\n\n RL CO Line Data:\n\n${errorMessage}\n\nRegards,\nRL BOT`,
  //     };

  //     await transporter.sendMail(mailOptions);
  //     return new CommonResponseModel(true, 1, "Email Sent Successfully");
  //   } else {
  //     console.log("No Failed Records");
  //     return new CommonResponseModel(false, 0, "No Records with Failed status");
  //   }
  // }

  async getCoLineDataAndSendEmail(): Promise<CommonResponseModel> {
    const formatDate = (date: Date): string => {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    };

    try {
      const today = new Date();
      const todaysDate = formatDate(today);
      console.log(todaysDate, "Today's Date");

      const response = await this.coLineRepo.getCoLineData();
      const data = response || [];
      const updatedData = data.map(item => {
        return {
          ...item,
          updated_at: item.updated_at ? new Date(item.updated_at).toISOString().split('T')[0] : null
        };
      });
      console.log(updatedData, "Updated Records");
      const coLineFailedData = updatedData.filter(item =>
        item.updated_at === todaysDate && item.status === "Failed"
      );
      console.log(coLineFailedData, `Failed Records On ${todaysDate}`);
      console.log(coLineFailedData[0], `Failed Records On ${todaysDate} of Object One`);

      if (coLineFailedData.length === 0) {
        return new CommonResponseModel(false, 0, `No Records With Failed Status On ${todaysDate}`);
      }
      const errorMessage = coLineFailedData.map(item => `
        PO Number: ${item.buyer_po}
        Buyer Name: RL
        PO Line: ${item.line_item_no}
        Item No: ${item.item_no}
        CO Number: ${item.co_number}
        CO Date: ${item.co_date}
        Status: ${item.status}
        Message: ${item.error_msg}
      `).join('\n\n');
      const recipientEmail = 'jaswanthpappala3@gmail.com';
      const ccEmails = ['jaswanthpappala3@gmail.com'];

      const transporter = nodemailer.createTransport({
        host: 'smtp.gmail.com',
        port: 587,
        secure: false,
        auth: {
          user: 'alerts@schemaxtech.com',
          pass: 'mzep lrqi mczj uezj'
        }
      });

      const mailOptions = {
        from: 'alerts@schemaxtech.com',
        to: recipientEmail,
        cc: ccEmails,
        subject: 'RL CO Line Failed Status',
        text: `Dear User,\n\n RL CO Line Data:\n\n${errorMessage}\n\nRegards,\nRL BOT`,
      };
      await transporter.sendMail(mailOptions);
      return new CommonResponseModel(true, 1, "Email sent successfully");
    } catch (error) {
      console.error("Error sending email:", error);
      return new CommonResponseModel(false, 0, "An error occurred while sending the email");
    }
  }

  async editCoLineCreationReq(req: any): Promise<CommonResponseModel> {
    try {
      if (req.itemNo == undefined || null) {
        return new CommonResponseModel(false, 0, 'Please enter Item No')
      };
      console.log(req, "tyryrryrurur")
      // const records = await this.rlOrdersRepo.find({ where: { poNumber: req.poNumber,poItem:req.poItem } });
      const empty = [];
      const entity = new EditRlCOLineEntity()
      entity.poItem = req.poItem
      entity.poNumber = req.poNumber
      entity.buyer = req.buyer
      entity.material = req.material
      entity.itemNo = req?.itemNo;
      entity.itemStatus = ItemStatusEnum.OPEN
      entity.createdUser = 'admin';
      entity.coDate = req?.coDate
      entity.coNumber = req?.coNumber
      empty.push(entity)
      const save = await this.editrlCoLineRepository.save(empty);
      if (save) {
        const update = await this.orderChildRepo.update(
          { poNumber: req.poNumber, poItem: req.poItem },
          { itemStatus: ItemStatusEnum.INPROGRESS }
        );
        return new CommonResponseModel(true, 1, 'Edit CO-Line request created successfully', save)
      } else {
        return new CommonResponseModel(false, 0, 'CO-Line request failed')
      }
    } catch (err) {
      return new CommonResponseModel(false, 0, 'CO-Line request failed', err)
    }
  }


  async getEditCoLineData(req?: RLOrderFilter): Promise<CommonResponseModel> {
    const data = await this.editrlCoLineRepository.getEditCoLineData(req)
    if (data.length > 0)
      return new CommonResponseModel(true, 1, 'data retrived', data)
    else
      return new CommonResponseModel(false, 0, 'No data found');
  }

  async deleteEditCoLine(req: ItemNoDtos): Promise<CommonResponseModel> {
    try {
      const deletedItem = await this.editrlCoLineRepository.delete({ poNumber: req.poNumber, poItem: req.poLine });
      if (deletedItem && deletedItem.affected) {
        return new CommonResponseModel(true, 1, "ItemNo Deleted Successfully");
      } else {
        return new CommonResponseModel(false, 0, "Item No: Something went wrong", []);
      }
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error occurred while deleting ItemNo", error);
    }
  }

  async updateStatusInOrderAcceptance(req: any): Promise<CommonResponseModel> {
    console.log(req, "reqOpenStatus")
    try {
      const update = await this.orderChildRepo.update(
        { poNumber: req.poNumber, poItem: req.poLine },
        { itemStatus: ItemStatusEnum.OPEN }
      );
      if (update) {
        return new CommonResponseModel(true, 1, "Updated Successfully");
      } else {
        return new CommonResponseModel(false, 0, "Something went wrong", []);
      }
    } catch (error) {
      return new CommonResponseModel(false, 0, "Error occurred while deleting ItemNo", error);
    }
  }

  // <div dojotype="struts:BindDiv" closable="false" preload="true" id="subCOntainer" label="  Style Orders  " href="OrderHome.action" loadingtext="Loading Orders tab..." errortext="Some Error Occured While Transaction" showerror="true" showloading="true" parsecontent="true" class="dojoTabPane" style="position: relative;">undefined</div>
  async getordercomparationData(req?: any): Promise<CommonResponseModel> {
    try {
      const Originaldata = await this.rlOrdersRepo.getordercomparationData(req)
      const compareModel: CompareModel[] = []
      for (const rec of Originaldata) {
        const getItemNumberCoNumberCoDate = await this.rlOrdersRepo.getItemsNo(rec.po_number, rec.po_item);
        const itemNumber = getItemNumberCoNumberCoDate.item_no
        const coNumber = getItemNumberCoNumberCoDate.co_number
        const coDate = getItemNumberCoNumberCoDate.co_date

        const childData = await this.orderChildRepo.find({
          where: {
            poNumber: rec.po_number, poItem: rec.po_item, size: rec.size
          }
        })
        if (childData.length > 0) {
          const oldData = childData[0];
          if (
            oldData.price !== rec.price ||
            oldData.handoverDate !== rec.handover_date ||
            oldData.quantity !== rec.quantity
          ) {
            compareModel.push(new CompareModel(
              rec.po_number,
              rec.po_item,
              rec.size,
              oldData.price,
              rec.price,
              oldData.handoverDate,
              rec.handover_date,
              oldData.quantity,
              rec.quantity,
              oldData.itemStatus,
              itemNumber || '-',
              coNumber || '-',
              coDate || '-',
              rec.material_no,
              rec.buyer

            ));
          }
        }
      }
      if (compareModel) {
        return new CommonResponseModel(true, 1, 'Data Retrived Sucessfully', compareModel);
      } else {
        return new CommonResponseModel(false, 0, 'No data found');
      }
    } catch (err) {
      throw err
    }
  }

  async getOrderDetailsForEditCOLine(req: OrderDetailsReq): Promise<CommonResponseModel> {
    try {
      const data = await this.rlOrdersRepo.find({ where: { poNumber: req.poNumber } });

      const destinationColSizesMap = new Map<string, Map<string, Map<string, { size: string, quantity: number, price: string }[]>>>();
      const poMap = new Map<string, RLOrdersEntity>();

      for (const rec of data) {
        poMap.set(rec.poNumber, rec);
        const dest = rec.shipToAddress

        if (!destinationColSizesMap.has(rec.poNumber)) {
          destinationColSizesMap.set(rec.poNumber, new Map<string, Map<string, { size: string, quantity: number, price: string }[]>>());
        }
        if (!destinationColSizesMap.get(rec.poNumber).has(dest)) {
          destinationColSizesMap.get(rec.poNumber).set(dest, new Map<string, { size: string, quantity: number, price: string }[]>());
        }

        const check = await this.colorRepo.find({
          where: {
            poNumber: rec.poNumber,
            rlField: rec.color
          }
        });
        if (Array.isArray(check) && check.length > 0) {
          const crmField = check[0].crmField;
          if (!destinationColSizesMap.get(rec.poNumber).get(dest).has(crmField)) {
            destinationColSizesMap.get(rec.poNumber).get(dest).set(crmField, []);
          }
          destinationColSizesMap.get(rec.poNumber).get(dest).get(crmField).push({ size: rec.size, quantity: rec.quantity, price: rec.price });
        } else {
          if (!destinationColSizesMap.get(rec.poNumber).get(dest).has(rec.color)) {
            destinationColSizesMap.get(rec.poNumber).get(dest).set(rec.color, []);
          }
          destinationColSizesMap.get(rec.poNumber).get(dest).get(rec.color).push({ size: rec.size, quantity: rec.quantity, price: rec.price });
        }
      }

      const coData = [];
      destinationColSizesMap.forEach((destColorSize, poNumber) => {
        const desArray = [];
        destColorSize.forEach((colorSizes, dest) => {
          const ColArray = [];
          colorSizes.forEach((sizes, color) => {
            const sizeArray = sizes.map(size => new Size(size.size, size.quantity, size.price));
            const col = new Color(color, sizeArray);
            ColArray.push(col);
          });
          const des = new Destination(dest, ColArray);
          desArray.push(des);
        });
        const poInfo = poMap.get(poNumber);
        const co = new CoLineModel(poInfo.poNumber, poInfo.poItem, poInfo.price, poInfo.currency, poInfo.handoverDate, poInfo.materialNo, desArray);
        coData.push(co);
      });

      if (coData.length > 0) {
        return new CommonResponseModel(true, 1, 'Data Retrieved Successfully', coData);
      } else {
        return new CommonResponseModel(false, 0, 'No data found');
      }
    } catch (err) {
      throw err;
    }
  }

  @Cron('*/10 * * * *')
  async editCOline(req: any): Promise<CommonResponseModel> {
    const po = await this.editrlCoLineRepository.getDataforCOLineEdit();
    console.log(po, "poooooooo")
    if (!po) {
      return new CommonResponseModel(false, 0, 'No CO-Line creation requests')
    }
    let driver = await new Builder().forBrowser(Browser.CHROME).build();
    try {
      await driver.get('http://intranetn.shahi.co.in:8080/ShahiExportIntranet/subApp?slNo=2447#');
      await driver.findElement(By.id('username')).sendKeys('99901347');
      await driver.findElement(By.id('password')).sendKeys('99901347');
      await driver.findElement(By.css('button.btn-primary')).click();
      await driver.sleep(5000)
      await driver.get('http://intranetn.shahi.co.in:8080/ShahiExportIntranet/subApp?slNo=2447')
      const newPAge = await driver.executeScript(
        `javascript:openAccessPage('http://intranet.shahi.co.in:8080/IntraNet/CRMPRDNEW.jsp', 'CRM', '2448', 'R', '99901347', 'N', '20634576', 'null');`
      );
      const windowHandles = await driver.getAllWindowHandles()
      await driver.switchTo().window(windowHandles[1]);
      const frame = await driver.findElement(By.id('mainFrame'));
      await driver.switchTo().frame(frame)
      // for (const po of poDetails) {
      console.log(po)
      const coLine = new CoLineRequest();
      let buyerValue1;
      let buyerValue2;
      let agent;
      let buyerAddress;
      let deliveryAddress;
      let pkgTerms;
      let paymentTerms;
      let styleNo;
      let coNumber
      // const poItemsArray = po.po_item.split(',').map(item => item.trim());
      if (po.buyer === 'RL') {
        const response = await this.getOrderDetailsForEditCOLine({ poNumber: po.po_number, poLine: po.po_item })
        // console.log(response,"resoooooo")
        const coData = response.data[0];
        // console.log(coData,"coDDD")
        coLine.buyerPo = coData.buyerPo;
        const months = [
          'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
          'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];
        const [day, monthAbbrev, year] = coData.deliveryDate.split('-');
        const month = (months.indexOf(monthAbbrev) + 1).toString().padStart(2, '0');
        coLine.deliveryDate = `${day}/${month}/${year}`
        const inputDate = new Date(year, Number(month) - 1, day)
        const sevenDaysBefore = new Date(inputDate);
        sevenDaysBefore.setDate(inputDate.getDate() - 7);
        const exFactoryDate = new Intl.DateTimeFormat('en-GB').format(sevenDaysBefore)
        coLine.exFactoryDate = exFactoryDate
        coLine.salesPrice = coData.salesPrice
        coLine.currency = coData.currency
        coLine.destinations = coData.destinations
        const parts = coData.destinations[0]?.name.split(',');
        const request = { country: parts[1].trim() }
        const address = await this.addressService.getAddressInfoByCountry(request);
        // console.log(address, "aaaaaadddddddd")
        const addressData = address.data[0];
        if (!addressData) {
          const update = await this.editrlCoLineRepository.update(
            { poNumber: po.po_number, poItem: po.po_item },
            { itemStatus: "Failed", errorMsg: "Address not matching", isActive: false }
          );
          const childDataUpdate = await this.orderChildRepo.update({ poNumber: po.po_number, poItem: po.po_item }, { itemStatus: ItemStatusEnum.FAILED })
          return new CommonResponseModel(false, 0, "Address not matching");
        }
        // NOK            Item number 310V	 does not exist
        styleNo = coData.styleNo
        buyerAddress = addressData?.buyerCode ? addressData?.buyerCode : 25;
        deliveryAddress = addressData?.deliveryCode
        buyerValue1 = "RAL-RALPH LAUREN"
        buyerValue2 = "RAL00001-RALPH LAUREN CORPORATION"
        agent = "-NA"
        pkgTerms = "STD-STD PACK"
        paymentTerms = "048-TT 15 DAYS"
      }
      const apps = await driver.wait(until.elementLocated(By.xpath('//*[@id="mainContainer"]/div[1]')));
      const allApps = await apps.findElements(By.tagName('span'));
      for (const app of allApps) {
        if ((await app.getAttribute('innerText')).includes('Style Orders')) {
          await driver.executeScript('arguments[0].click();', app);
          break;
        }
      }
      await driver.wait(until.elementLocated(By.id('styleid2H')))
      await driver.findElement(By.id('styleid2H')).sendKeys(po.item_no);
      await driver.sleep(5000)

      await driver.wait(until.elementLocated(By.id('bgpset1')));
      const dropDonwElement1 = await driver.findElement(By.id('bgpset1'));
      const dropDown1 = await driver.wait(until.elementIsVisible(dropDonwElement1)).then(element => new Select(element))
      await dropDown1.selectByValue("RAL-RALPH LAUREN")
      await driver.sleep(10000)

      await driver.wait(until.elementLocated(By.id('byr')));
      const dropdownElement2 = await driver.findElement(By.id('byr'));
      const dropdown2 = await driver.wait(until.elementIsVisible(dropdownElement2)).then(element => new Select(element))
      await dropdown2.selectByValue("RAL00001-RALPH LAUREN CORPORATION")
      await driver.sleep(3000)

      await driver.wait(until.elementLocated(By.id('ViewOrderID')))
      await driver.findElement(By.id('ViewOrderID')).click();
      await driver.sleep(30000)

      let j;
      for (let i = 1; i <= 1000; i++) {
        const buyerpoPath = `//*[@id="form2"]/table/tbody/tr[2]/td/div/table/tbody/tr[${i}]/td[4]`;
        const BuyerPoelementContainingNumber = await driver.findElement(By.xpath(buyerpoPath));
        const textContainingBuyerPo = await BuyerPoelementContainingNumber.getText();
        // console.log(textContainingBuyerPo,"textContainingBuyerPo")
        // console.log(textContainingBuyerPo===po.po_number,"iiiiiiiii")
        if (textContainingBuyerPo === po.po_number) {
          // console.log(textContainingBuyerPo===po.po_number,"pooooooo")
          j = i
          break;
        }
      }

      const viewButtonPo = await driver.findElement(By.xpath(`//*[@id="form2"]/table/tbody/tr[2]/td/div/table/tbody/tr[${j}]/td[21]/div`));
      await viewButtonPo.click();
      await driver.sleep(10000)

      await driver.wait(until.elementLocated(By.id('bpo')))
      await driver.findElement(By.id('bpo')).clear();
      await driver.findElement(By.id('bpo')).sendKeys(coLine.buyerPo);

      await driver.wait(until.elementLocated(By.id('bus')))
      await driver.findElement(By.id('bus')).clear();
      await driver.findElement(By.id('bus')).sendKeys(styleNo);

      await driver.wait(until.elementLocated(By.id('agnt')));
      const agentDropDown = await driver.findElement(By.id('agnt'));
      await driver.executeScript(`arguments[0].value = '${agent}';`, agentDropDown)

      const revisedPoData = await this.getOrderDetailsForEditCOLine({ poNumber: po.po_number, poLine: po.po_item })
      const revisedData = revisedPoData.data[0];
      const newData = await this.orderChildRepo.find({
        where: { poNumber: po.po_number, poItem: po.po_item }
      });
      const groupedData = newData.reduce((acc, data) => {
        const key = `${data.poNumber}${data.poItem}`;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(data);
        return acc;
      }, {});

      const filteredData = Object.values(groupedData).flatMap((group: any) => {
        const maxVersion = Math.max(...group.map((item: any) => parseInt(item.poVersion, 10)));
        return group.filter(item => parseInt(item.poVersion, 10) < maxVersion);
      });

      const reStructedData = filteredData.map(data => ({
        poNumber: data.poNumber,
        poLine: data.poItem,
        poVersion: data.poVersion,
        details: {
          price: data.price,
          currency: data.currency,
          deliveryDate: data.handoverDate,
          materialNo: data.materialNo,
        },
      }));
      const oldData = reStructedData[0]
      // console.log(revisedData, "revisedData")
      // console.log(oldData, "oldData")
      if (revisedData.buyerPo === oldData.poNumber) {
        if (oldData.details.deliveryDate !== revisedData.deliveryDate) {
          console.log('Delivery Date Entered');
          await driver.wait(until.elementLocated(By.name('dojo.delydt')));
          await driver.findElement(By.name('dojo.delydt')).clear();
          await driver.findElement(By.name('dojo.delydt')).sendKeys(coLine.deliveryDate);
          const delDateCheckBox = await driver.wait(until.elementLocated(By.name('delicopy')), 2000)
          await delDateCheckBox.click();
          await driver.sleep(1000)
          // await driver.wait(until.elementLocated(By.name('dojo.EXFACTORYDATE')));
          // await driver.findElement(By.name('dojo.EXFACTORYDATE')).clear();
          // await driver.findElement(By.name('dojo.EXFACTORYDATE')).sendKeys(coLine.exFactoryDate);
          // const exFactoryDateCheckBox = await driver.wait(until.elementLocated(By.name('exfacdatecopy')), 2000)
          // await exFactoryDateCheckBox.click();
          // await driver.sleep(1000)
        } else {
          console.log("Del Date Not Matches && Not Selected Check Box")
        }
      }

      await driver.wait(until.elementLocated(By.name('byd')));
      const dropdown = await driver.findElement(By.name('byd'));
      const options = await dropdown.findElements(By.tagName('option'));
      const optionValues = [];
      for (const option of options) {
        const value = await option.getAttribute('value');
        optionValues.push(value);
      }
      const number = optionValues.find(value => value.includes(buyerAddress));
      await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
      console.log(buyerAddress, "buyeeeeeeee")

      await driver.wait(until.elementLocated(By.xpath('//*[@id="cur"]')));
      const curDropdown = await driver.findElement(By.xpath('//*[@id="cur"]'));
      const cur = coLine.currency;
      await driver.executeScript(`arguments[0].value = '${cur}';`, curDropdown);

      // await driver.wait(until.elementLocated(By.xpath('//*[@id="price"]')));
      // await driver.findElement(By.xpath('//*[@id="price"]')).clear();
      // await driver.findElement(By.xpath('//*[@id="price"]')).sendKeys(coLine.salesPrice);

      if (revisedData.buyerPo === oldData.poNumber) {
        if (oldData.details.price !== revisedData.salesPrice) {
          console.log('Sales Price Entered');
          await driver.wait(until.elementLocated(By.xpath('//*[@id="price"]')));
          await driver.findElement(By.xpath('//*[@id="price"]')).clear();
          await driver.findElement(By.xpath('//*[@id="price"]')).sendKeys(coLine.salesPrice);
          const salesPriceCheckBox = await driver.wait(until.elementLocated(By.name('pricecopy')), 2000)
          await salesPriceCheckBox.click();
          await driver.sleep(1000)
        } else {
          console.log("Sales Price Not Matches && Not Selected Check Box")
        }
      }

      await driver.wait(until.elementLocated(By.id('packtrm')));
      const pkgTermsDropDown = await driver.findElement(By.id('packtrm'));
      await driver.executeScript(`arguments[0].value = '${pkgTerms}';`, pkgTermsDropDown)

      await driver.wait(until.elementLocated(By.id('ptr')));
      const ptrDropDown = await driver.findElement(By.id('ptr'));
      await driver.executeScript(`arguments[0].value = '${paymentTerms}';`, ptrDropDown)
      await driver.sleep(2000)

      for (let dest of coLine.destinations) {
        const colorsContainer = await driver.wait(until.elementLocated(By.xpath('//*[@id="COContainer"]')));
        const colorsTabs = await colorsContainer.findElements(By.tagName('span'));
        for (const tab of colorsTabs) {
          if ((await tab.getAttribute('innerText')) == dest.name) {
            await driver.executeScript('arguments[0].click();', tab);
            for (let [colorIndex, color] of dest.colors.entries()) {
              for (let [sizeIndex, size] of color.sizes.entries()) {
                if (colorIndex === 0) {
                  // Find all the labels in the second row.
                  await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                  let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                  const fileteredElements: any[] = [];
                  for (const labelElement of labelElements) {
                    const ele = (await labelElement.getText())?.trim();
                    ele.length > 0 ? fileteredElements.push(labelElement) : '';
                  }
                  let tabIndex = 1; // Default to 1 if no match
                  const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                  const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                  await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                  const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                  const options = await dropdown.findElements(By.tagName('option'));
                  const optionValues = [];
                  for (const option of options) {
                    const value = await option.getAttribute('value');
                    optionValues.push(value);
                  }
                  const number = optionValues.find(value => value.includes(deliveryAddress)); // give the dynamic value here
                  await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                  // Find all the input fields in the first row.
                  const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                  // Create a map of size labels to input fields.
                  const sizeToInputMap = {};
                  for (let i = 0; i < fileteredElements.length; i++) {
                    const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString(); // Remove leading/trailing spaces
                    if (label.length)
                      sizeToInputMap[label] = inputElements[i];
                  }
                  const inputField = await sizeToInputMap[size.name.trim().toUpperCase().toString()];
                  if (inputField) {
                    // Clear the existing value (if any) and fill it with the new price.
                    await inputField.clear();
                    await inputField.sendKeys(size.price);
                  }
                }
                const inputId = `${size.name}:${color.name.toString().toUpperCase().trim()}:${dest.name}`.replace(/\*/g, '');
                const input = await driver.wait(until.elementLocated(By.id(inputId)))
                await driver.findElement(By.id(inputId)).sendKeys(`${size.qty}`);
              }
            }
          }
          else if ((await tab.getAttribute('innerText')) == 'ASSORTED*') {
            await driver.sleep(10000)
            await driver.executeScript('arguments[0].click();', tab);
            const sizesDivElementId = `nameDiv1${po.item_no}ZD001`;
            const colorsDivElementId = `nameDiv3${po.item_no}ZD001`;
            // parent div ids
            /**
             * to read sizes : nameDiv1359QZD001
             * to read colors : nameDiv3359QZD001   nameDiv3744QZD001
             * to read input fields: percentageDiv1359QZD001
             * 
             */
            const allSizes = [];
            console.log('---------------------------------------------------------------');
            await driver.wait(until.elementLocated(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`)));
            // -----------------------   SIZES Reading from UI logic start ---------------
            // read all the sizes from the DOM
            let labelElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
            const totalElements = labelElements?.length;
            console.log('Total elements : ' + totalElements);
            labelElements.forEach(async r => {
              const label = (await r.getText()).trim().toUpperCase().toString();
              allSizes.push(label);
            });
            // Now iterate a random iteration of 10 loops to cover all sizes in the UI by doing a horizontal scroll
            let i = 1;
            while (i <= 10) {
              // Try to jump to right hand side of the div by 8 units. (Dont try more than that. Test and change this value if needed)
              const toJump = Math.min(i * 8, totalElements);
              const rightEle = driver.findElement(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td[${toJump}]`));
              // scroll the pointer to right side
              driver.executeScript("arguments[0].scrollIntoView()", rightEle);
              driver.sleep(1000);
              // read all the visible sizes from the DOM
              let currentUserVisbileElements: any[] = await driver.findElements(By.xpath(`//div[@id='${sizesDivElementId}']/table/tbody/tr[2]/td/div`));
              // At some nth iteration, we can set all the sizes to the array once it is visible on the scope of selenium reader
              console.log("Iteration " + i + " : " + toJump + " --- " + currentUserVisbileElements.length);
              currentUserVisbileElements.forEach(async (r, index) => {
                if (allSizes[index] == '') {
                  const label = (await r.getText()).trim().toUpperCase().toString();
                  allSizes[index] = label;
                }
              });
              console.log(allSizes);
              i++;
            }
            // construct a reverse mapping of size => column location for easy scrolling during qty input
            const sizeToDisplayRowColumnIndex = [];
            allSizes.forEach((size, i) => {
              sizeToDisplayRowColumnIndex[size] = i;
            })
            // -----------------------   SIZES Reading from UI logic END ---------------
            // ---------------------- COLOR GETTING LOGIC START -------------------------
            const colorsInTable = [];
            const colorsToDisplayRowColumnIndex = [];
            // get the total colors for the current PO from the UI
            const totalColorElements: any[] = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr`));
            console.log('total colors : ' + totalColorElements.length);
            let cc = 0;
            for (const r of totalColorElements) {
              // scroll to the specific location in the screen to read the color 
              const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]`));
              // execute the scroll command
              await driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
              await driver.sleep(500);
              // now after scrolling, read the element from the DOM again. This time the selenium can read the value present in the DOM
              const sepcificRowColorEle = await driver.findElements(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${cc + 1}]/td`));
              console.log(sepcificRowColorEle, "sepcificRowColorEle");
              const displayingColor = (await sepcificRowColorEle[0]?.getText());
              colorsInTable.push(displayingColor);
              cc++;
            }
            colorsInTable.forEach((color, index) => {
              colorsToDisplayRowColumnIndex[color] = index;
              console.log(colorsInTable, "colorsInTable")
            });
            // ---------------------- COLOR GETTING LOGIC END -------------------------

            for (let [colorIndex, color] of dest.colors.entries()) {
              const exactColorRowScrollLocation = colorsToDisplayRowColumnIndex[color.name] + 1;
              if (colorsToDisplayRowColumnIndex[color.name] == undefined || colorsToDisplayRowColumnIndex[color.name] == null) {
                const update = await this.editrlCoLineRepository.update(
                  { poNumber: po.po_number, poItem: po.po_item },
                  { itemStatus: "Failed", errorMsg: "No Color Matching Found", isActive: false }
                );
                const childDataUpdate = await this.orderChildRepo.update({ poNumber: po.po_number, poItem: po.po_item }, { itemStatus: ItemStatusEnum.FAILED })
                return new CommonResponseModel(false, 0, 'No Matching Color Found')
              }
              const bottomEle = await driver.findElement(By.xpath(`//div[@id='${colorsDivElementId}']/table/tbody/tr[${exactColorRowScrollLocation}]`));
              driver.executeScript("arguments[0].scrollIntoView()", bottomEle);
              driver.sleep(500);
              for (let [sizeIndex, size] of color.sizes.entries()) {
                const exactSizeColumnScrollLocation = sizeToDisplayRowColumnIndex[size.name] + 1;
                if (!exactSizeColumnScrollLocation) {
                  const update = await this.editrlCoLineRepository.update(
                    { poNumber: po.po_number, poItem: po.po_item },
                    { itemStatus: "Failed", errorMsg: "NO matching Size found", isActive: false }
                  );
                  const childDataUpdate = await this.orderChildRepo.update({ poNumber: po.po_number, poItem: po.po_item }, { itemStatus: ItemStatusEnum.FAILED })
                  return new CommonResponseModel(false, 0, 'NO matching Size found')
                }
                const colorArray: any[] = []
                const sizes: any[] = []
                if (colorIndex >= 0) {
                  await driver.wait(until.elementLocated(By.xpath(`//*[@id="${colorsDivElementId}"]/table/tbody/tr/td[1]`)))
                  let colorElements: any[] = await driver.findElements(By.xpath(`//*[@id="${colorsDivElementId}"]/table/tbody/tr/td[1]`));
                  for (const colorElement of colorElements) {
                    const ele = await colorElement.getAttribute('innerText');
                    colorArray.push(ele);
                  }
                  await driver.wait(until.elementLocated(By.xpath("//tbody/tr[2]/td/div")))
                  let labelElements: any[] = await driver.findElements(By.xpath("//tbody/tr[2]/td/div"));
                  const fileteredElements: any[] = [];
                  for (const labelElement of labelElements) {
                    const ele = (await labelElement.getText())?.trim();
                    ele.length > 0 ? fileteredElements.push(labelElement) : '';
                  }
                  let tabIndex = 1;
                  const inputElementsXPath = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div[${tabIndex}]/div/table/tbody/tr/td[2]/table/tbody/tr[1]/td/div/table/tbody/tr[1]/td/div/input[@name='salespsizes']`;
                  const string = `${po.item_no}ZD${tabIndex.toString().padStart(3, '0')}`
                  await driver.wait(until.elementLocated(By.id(`bydline/${string}`)));
                  const dropdown = await driver.findElement(By.id(`bydline/${string}`));
                  const options = await dropdown.findElements(By.tagName('option'));
                  const optionValues = [];
                  for (const option of options) {
                    const value = await option.getAttribute('value');
                    optionValues.push(value);
                  }
                  const number = optionValues.find(value => {
                    return Number(value.split('-')[0].trim()) == Number(deliveryAddress)
                  });
                  await driver.executeScript(`arguments[0].value = '${number}';`, dropdown);
                  const inputElements = await driver.findElements(By.xpath(inputElementsXPath));
                  const sizeToInputMap = {};
                  for (let i = 0; i < fileteredElements.length; i++) {
                    const label = (await fileteredElements[i].getText()).trim().toUpperCase().toString();
                    sizes.push(label)
                    if (label.length)
                      sizeToInputMap[label] = inputElements[i];
                  }
                }
                // console.log(size.name,"sosisisissi")
                // console.log(color.name,"ghghghghggh")
                // console.log(`${color.name.toUpperCase().toString().trim()}:ASSORTED`.replace(/\*/g, ''),"}}__+_+__[")
                // console.log(`${size.name}:${color.name.toUpperCase().toString().trim()}:ASSORTED`.replace(/\*/g, ''),"454747[p][[")
                const colIndex = colorArray.indexOf(color.name)
                const sizeIndex = sizes.indexOf(size.name)

                if (colIndex !== -1 && sizeIndex !== -1) {
                  const inputId = `/html/body/div[2]/div[2]/table/tbody/tr/td/div[6]/form/table/tbody/tr/td/table/tbody/tr[5]/td/div/div[2]/div/div/table/tbody/tr/td[2]/table/tbody/tr[2]/td/div/table/tbody/tr[${colIndex + 1}]/td[${(sizeIndex + 1) * 2 - 1}]/input[1]`
                  console.log(inputId, 'IIIIIIIIIIII')
                  const input = await driver.wait(until.elementLocated(By.xpath(inputId)), 20000)
                  console.log(input)
                  const currentValue = await input.getAttribute('value');
                  console.log(size.qty, "size.qty")
                  input.sendKeys(Key.chord(Key.CONTROL, "a"), size.qty);
                } else {
                  const createInputId = `${size.name}:${color.name.toUpperCase().toString().trim()}:ASSORTED`.replace(/\*/g, '');
                  await driver.wait(until.elementLocated(By.id(createInputId)), 8000)
                  await driver.findElement(By.id(createInputId)).sendKeys(`${size.qty}`);
                }
              }
            }
          }
        }
      }
      await driver.sleep(9000)
      const element = await driver.findElement(By.id('createorder')).click();
      if (await this.isUpdateAlertPresent(driver)) {
        const alert = await driver.switchTo().alert();
        const alertText = await alert.getText();
        console.log(alertText, "alertText")
        const update = await this.editrlCoLineRepository.update(
          { poNumber: po.po_number, poItem: po.po_item },
          { itemStatus: "Failed", errorMsg: alertText, isActive: false }
        );
        const childDataUpdate = await this.orderChildRepo.update({ poNumber: po.po_number, poItem: po.po_item }, { itemStatus: ItemStatusEnum.FAILED })
        await alert.accept();
        await driver.sleep(4000)
        await driver.navigate().refresh();
        return new CommonResponseModel(false, 0, alertText)
      }
      else {
        await driver.sleep(8000)
        await driver.wait(until.elementLocated(By.xpath('//*[@id="orno"]')), 10000);
        const coNoElement = await driver.findElement(By.xpath('//*[@id="orno"]'));
        const coNo = await coNoElement.getAttribute('value');
        await driver.sleep(5000)
        const currentDate = new Date();
        const day = currentDate.getDate().toString().padStart(2, '0');
        const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(currentDate);
        const year = currentDate.getFullYear().toString().slice(-2);
        const currentDateFormatted = `${day}-${month}-${year}`;
        if (coNo) {
          const update = await this.editrlCoLineRepository.update(
            { poNumber: po.po_number, poItem: po.po_item },
            { coNumber: coNo, coDate: currentDateFormatted, itemStatus: "Success", errorMsg: "-" }
          );
          const childDataUpdate = await this.orderChildRepo.update({ poNumber: po.po_number, poItem: po.po_item }, { itemStatus: ItemStatusEnum.SUCCESS })
          await driver.sleep(10000)
          return new CommonResponseModel(true, 1, `COline Updated successfully`)
        } else {
          const update = await this.editrlCoLineRepository.update(
            { poNumber: po.po_number, poItem: po.po_item },
            { itemStatus: "Failed", errorMsg: "CO Number Not Found", isActive: false }
          );
          const childDataUpdate = await this.orderChildRepo.update({ poNumber: po.po_number, poItem: po.po_item }, { itemStatus: ItemStatusEnum.FAILED })
          await driver.sleep(10000)
        }
      }
      return new CommonResponseModel(true, 1, `COline Updated successfully`)
    }
    catch (error) {
      console.log(error, 'error');
      if (error.name === "UnexpectedAlertOpenError") {
        const unExcepectedAlert = error.alertText;
        const update = await this.editrlCoLineRepository.update(
          { poNumber: po.po_number, poItem: po.po_item },
          { itemStatus: "Failed", errorMsg: unExcepectedAlert, isActive: false }
        );
        const childDataUpdate = await this.orderChildRepo.update({ poNumber: po.po_number, poItem: po.po_item }, { itemStatus: ItemStatusEnum.FAILED })
        return new CommonResponseModel(false, 0, 'unExcepectedAlert Error', unExcepectedAlert);
      } else {
        const update = await this.editrlCoLineRepository.update(
          { poNumber: po.po_number, poItem: po.po_item },
          { itemStatus: "Failed", errorMsg: error.name, isActive: false }
        );
        const childDataUpdate = await this.orderChildRepo.update({ poNumber: po.po_number, poItem: po.po_item }, { itemStatus: ItemStatusEnum.FAILED })
        return new CommonResponseModel(false, 0, 'error', error.name)
      }
    }
    finally {
      driver.quit()
    }
  }

  async isUpdateAlertPresent(driver) {
    try {
      await driver.switchTo().alert();
      return true;
    } catch (e) {
      return false;
    }
  }

}






